var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironmentillustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 178,
    viewBox: "0 0 302 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_8101)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_491_8101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.568 -107.523H-17.2387V94.2219H406.568V-107.523Z",
    fill: "url(#paint0_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.552 13.5047V-10.1713H320.172V-18.3412H315.802V-20.9783L312.966 -24.192V-35.2596L311.094 -36.9289V-40.7925H310.418H309.742V-36.9289L307.868 -35.2596V-24.192L305.032 -20.9783V-18.3412H300.662V-10.1713H298.282V13.5047H296.839V29.1839V94.1934H323.997V29.1839V13.5047H322.552Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.472 -12.9886V-21.1567H135.141V-12.9886H131.125V94.2221H152.488V-12.9886H148.472Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.963 -12.9886V-21.1567H160.632V-12.9886H156.616V94.2221H177.981V-12.9886H173.963Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.395 12.6295H250.484V-18.9933H260.577V94.2216H245.395V12.6295Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.872 -7.86497H288.783V-18.9933H278.688V94.2216H293.872V-7.86497Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.747 -10.8468V-14.0623H221.528V-10.8468H219.056V94.1589H242.433V-10.8468H240.747Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.456 38.0559H231.345V36.7187H229.456V38.0559Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.827 38.0559H236.715V36.7187H234.827V38.0559Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.144 20.5874H238.032V19.2502H236.144V20.5874Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.839 20.5874H240.728V19.2502H238.839V20.5874Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 45.1443H229.605V43.807H227.717V45.1443Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 45.1443H232.651V43.807H230.763V45.1443Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 45.1443H229.606V43.807H227.717V45.1443Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.671 45.1443H226.56V43.807H224.671V45.1443Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.626 45.1443H223.514V43.807H221.626V45.1443Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.458 45.1443H235.346V43.807H233.458V45.1443Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 45.1443H238.041V43.807H236.153V45.1443Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.716 57.1927H229.604V55.8555H227.716V57.1927Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.716 62.1919H229.604V60.8546H227.716V62.1919Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.762 57.1927H232.651V55.8555H230.762V57.1927Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.457 57.1927H235.346V55.8555H233.457V57.1927Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 57.1927H238.042V55.8555H236.153V57.1927Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 48.687H229.605V47.3498H227.717V48.687Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 48.687H232.651V47.3498H230.763V48.687Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 48.687H229.606V47.3498H227.717V48.687Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.671 48.687H226.56V47.3498H224.671V48.687Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.626 48.687H223.514V47.3498H221.626V48.687Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.458 48.687H235.346V47.3498H233.458V48.687Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 48.687H238.041V47.3498H236.153V48.687Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 65.0289H229.605V63.6917H227.717V65.0289Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 65.0289H232.651V63.6917H230.763V65.0289Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 65.0289H229.606V63.6917H227.717V65.0289Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.671 65.0289H226.56V63.6917H224.671V65.0289Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.626 65.0289H223.514V63.6917H221.626V65.0289Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.458 65.0289H235.346V63.6917H233.458V65.0289Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 65.0289H238.041V63.6917H236.153V65.0289Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 69.1906H229.605V67.8533H227.717V69.1906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 69.1906H232.651V67.8533H230.763V69.1906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 69.1906H229.606V67.8533H227.717V69.1906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.671 69.1906H226.56V67.8533H224.671V69.1906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.626 69.1906H223.514V67.8533H221.626V69.1906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.458 69.1906H235.346V67.8533H233.458V69.1906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 69.1906H238.041V67.8533H236.153V69.1906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 73.3513H229.605V72.0141H227.717V73.3513Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 73.3513H232.651V72.0141H230.763V73.3513Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 73.3513H229.606V72.0141H227.717V73.3513Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.671 73.3513H226.56V72.0141H224.671V73.3513Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.626 73.3513H223.514V72.0141H221.626V73.3513Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.458 73.3513H235.346V72.0141H233.458V73.3513Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 73.3513H238.041V72.0141H236.153V73.3513Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 41.6006H229.605V40.2633H227.717V41.6006Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 41.6006H232.651V40.2633H230.763V41.6006Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 41.6006H229.606V40.2633H227.717V41.6006Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.671 41.6006H226.56V40.2633H224.671V41.6006Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.626 41.6006H223.514V40.2633H221.626V41.6006Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.458 41.6006H235.346V40.2633H233.458V41.6006Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 41.6006H238.041V40.2633H236.153V41.6006Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 24.7498H229.605V23.4125H227.717V24.7498Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 24.7498H232.651V23.4125H230.763V24.7498Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 24.7498H229.606V23.4125H227.717V24.7498Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.671 24.7498H226.56V23.4125H224.671V24.7498Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.626 24.7498H223.514V23.4125H221.626V24.7498Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.458 24.7498H235.346V23.4125H233.458V24.7498Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 24.7498H238.041V23.4125H236.153V24.7498Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.041 3.94397L232.93 3.94397V2.60671H231.041V3.94397Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.087 3.94397L235.976 3.94397V2.60671H234.087V3.94397Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.043 3.94397L232.931 3.94397V2.60671H231.043V3.94397Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.996 3.94397L229.884 3.94397V2.60671H227.996V3.94397Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.95 3.94397L226.839 3.94397V2.60671H224.95V3.94397Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 28.9115H229.605V27.5742H227.717V28.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 28.9115H232.651V27.5742H230.763V28.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.717 28.9115H229.606V27.5742H227.717V28.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.671 28.9115H226.56V27.5742H224.671V28.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.626 28.9115H223.514V27.5742H221.626V28.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.458 28.9115H235.346V27.5742H233.458V28.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.153 28.9115H238.041V27.5742H236.153V28.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1556 -17.8379V-21.2694H13.9368V-17.8379H11.4651V94.1594H34.8423V-17.8379H33.1556Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8665 34.3202H23.7549V32.8937H21.8665V34.3202Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2375 34.3202H29.126V32.8937H27.2375V34.3202Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5519 15.6885H30.4404V14.2619H28.5519V15.6885Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2475 15.6885H33.136V14.2619H31.2475V15.6885Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 41.8793H22.0155V40.4528H20.127V41.8793Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1732 41.8793H25.0616V40.4528H23.1732V41.8793Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1286 41.8793H22.0171V40.4528H20.1286V41.8793Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0818 41.8793H18.9703V40.4528H17.0818V41.8793Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0363 41.8793H15.9247V40.4528H14.0363V41.8793Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 41.8793H27.7568V40.4528H25.8684V41.8793Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 41.8793H30.4512V40.4528H28.5627V41.8793Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1251 54.7319H22.0136V53.3054H20.1251V54.7319Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1251 60.0648H22.0136V58.6383H20.1251V60.0648Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.173 54.7319H25.0615V53.3054H23.173V54.7319Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8682 54.7319H27.7567V53.3054H25.8682V54.7319Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5625 54.7319H30.451V53.3054H28.5625V54.7319Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1272 45.6583H22.0157V44.2318H20.1272V45.6583Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1734 45.6583H25.0619V44.2318H23.1734V45.6583Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1291 45.6583H22.0176V44.2318H20.1291V45.6583Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0819 45.6583H18.9703V44.2318H17.0819V45.6583Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0367 45.6583H15.9252V44.2318H14.0367V45.6583Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8688 45.6583H27.7573V44.2318H25.8688V45.6583Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5629 45.6583H30.4514V44.2318H28.5629V45.6583Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 63.0879H22.0155V61.6614H20.127V63.0879Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1732 63.0879H25.0616V61.6614H23.1732V63.0879Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1287 63.0879H22.0172V61.6614H20.1287V63.0879Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0816 63.0879H18.9701V61.6614H17.0816V63.0879Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0363 63.0879H15.9247V61.6614H14.0363V63.0879Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 63.0879H27.7568V61.6614H25.8684V63.0879Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 63.0879H30.4512V61.6614H28.5627V63.0879Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 67.5267H22.0155V66.1002H20.127V67.5267Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1732 67.5267H25.0616V66.1002H23.1732V67.5267Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1286 67.5267H22.0171V66.1002H20.1286V67.5267Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0818 67.5267H18.9703V66.1002H17.0818V67.5267Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0363 67.5267H15.9247V66.1002H14.0363V67.5267Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 67.5267H27.7568V66.1002H25.8684V67.5267Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 67.5267H30.4512V66.1002H28.5627V67.5267Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 71.9659H22.0155V70.5394H20.127V71.9659Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1732 71.9659H25.0616V70.5394H23.1732V71.9659Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1286 71.9659H22.0171V70.5394H20.1286V71.9659Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0818 71.9659H18.9703V70.5394H17.0818V71.9659Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0363 71.9659H15.9247V70.5394H14.0363V71.9659Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 71.9659H27.7568V70.5394H25.8684V71.9659Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 71.9659H30.4512V70.5394H28.5627V71.9659Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 38.0991H22.0155V36.6726H20.127V38.0991Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1732 38.0991H25.0616V36.6726H23.1732V38.0991Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1286 38.0991H22.0171V36.6726H20.1286V38.0991Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0818 38.0991H18.9703V36.6726H17.0818V38.0991Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0363 38.0991H15.9247V36.6726H14.0363V38.0991Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 38.0991H27.7568V36.6726H25.8684V38.0991Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 38.0991H30.4512V36.6726H28.5627V38.0991Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 20.1277H22.0155V18.7012H20.127V20.1277Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1732 20.1277H25.0616V18.7012H23.1732V20.1277Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1286 20.1277H22.0171V18.7012H20.1286V20.1277Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0818 20.1277H18.9703V18.7012H17.0818V20.1277Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0363 20.1277H15.9247V18.7012H14.0363V20.1277Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 20.1277H27.7568V18.7012H25.8684V20.1277Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 20.1277H30.4512V18.7012H28.5627V20.1277Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 24.5648H22.0155V23.1383H20.127V24.5648Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1732 24.5648H25.0616V23.1383H23.1732V24.5648Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1286 24.5648H22.0171V23.1383H20.1286V24.5648Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0818 24.5648H18.9703V23.1383H17.0818V24.5648Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0363 24.5648H15.9247V23.1383H14.0363V24.5648Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 24.5648H27.7568V23.1383H25.8684V24.5648Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 24.5648H30.4512V23.1383H28.5627V24.5648Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7165 -39.9503V-3.24992H77.2604V94.2215H118.258V-39.9503H96.7165Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8448 6.82703H83.4513V8.22678H84.8448V6.82703Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1849 6.82703H85.7914V8.22678H87.1849V6.82703Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5246 6.82703H88.1312V8.22678H89.5246V6.82703Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8645 6.82703H90.471V8.22678H91.8645V6.82703Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 9.8208H83.4507V11.2206H84.8442V9.8208Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 9.8208H85.7913V11.2206H87.1847V9.8208Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 9.8208H88.1304V11.2206H89.5239V9.8208Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 9.8208H90.4709V11.2206H91.8644V9.8208Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 12.8135H83.4507V14.2132H84.8442V12.8135Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 12.8136H85.7913V14.2133H87.1847V12.8136Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 12.8136H88.1304V14.2133H89.5239V12.8136Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 12.8136H90.4709V14.2133H91.8644V12.8136Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 15.8075H83.4507V17.2072H84.8442V15.8075Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 15.8075H85.7913V17.2072H87.1847V15.8075Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 15.8075H88.1304V17.2072H89.5239V15.8075Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 15.8075H90.4709V17.2072H91.8644V15.8075Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 18.8016H83.4507V20.2014H84.8442V18.8016Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 18.8016H85.7913V20.2014H87.1847V18.8016Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 18.8016H88.1304V20.2014H89.5239V18.8016Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 18.8016H90.4709V20.2014H91.8644V18.8016Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 21.7939H83.4507V23.1937H84.8442V21.7939Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 21.7939H85.7913V23.1937H87.1847V21.7939Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 21.7939H88.1304V23.1937H89.5239V21.7939Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 21.7939H90.4709V23.1937H91.8644V21.7939Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 24.7883H83.4507V26.1881H84.8442V24.7883Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 24.7883H85.7913V26.1881H87.1847V24.7883Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 24.7883H88.1304V26.1881H89.5239V24.7883Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 24.7883H90.4709V26.1881H91.8644V24.7883Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 27.7804H83.4507V29.1801H84.8442V27.7804Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 27.7805H85.7913V29.1803H87.1847V27.7805Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 27.7805H88.1304V29.1803H89.5239V27.7805Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 27.7805H90.4709V29.1803H91.8644V27.7805Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 30.7745H83.4507V32.1743H84.8442V30.7745Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 30.7745H85.7913V32.1743H87.1847V30.7745Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 30.7745H88.1304V32.1743H89.5239V30.7745Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 30.7745H90.4709V32.1743H91.8644V30.7745Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 33.7668H83.4507V35.1666H84.8442V33.7668Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 33.7667H85.7913V35.1665H87.1847V33.7667Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 33.7667H88.1304V35.1665H89.5239V33.7667Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 33.7667H90.4709V35.1665H91.8644V33.7667Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 36.761H83.4507V38.1607H84.8442V36.761Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 36.7611H85.7913V38.1608H87.1847V36.7611Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 36.7611H88.1304V38.1608H89.5239V36.7611Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 36.7611H90.4709V38.1608H91.8644V36.7611Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 39.755H83.4507V41.1548H84.8442V39.755Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 39.755H85.7913V41.1548H87.1847V39.755Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 39.755H88.1304V41.1548H89.5239V39.755Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 39.755H90.4709V41.1548H91.8644V39.755Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 42.7468H83.4507V44.1466H84.8442V42.7468Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 42.7469H85.7913V44.1467H87.1847V42.7469Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 42.7469H88.1304V44.1467H89.5239V42.7469Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 42.7469H90.4709V44.1467H91.8644V42.7469Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 45.7407H83.4507V47.1405H84.8442V45.7407Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 45.7407H85.7913V47.1405H87.1847V45.7407Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 45.7407H88.1304V47.1405H89.5239V45.7407Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 45.7407H90.4709V47.1405H91.8644V45.7407Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 48.7352H83.4507V50.135H84.8442V48.7352Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 48.7352H85.7913V50.135H87.1847V48.7352Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 48.7352H88.1304V50.135H89.5239V48.7352Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 48.7352H90.4709V50.135H91.8644V48.7352Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 51.7277H83.4507V53.1274H84.8442V51.7277Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 51.7278H85.7913V53.1275H87.1847V51.7278Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 51.7278H88.1304V53.1275H89.5239V51.7278Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 51.7278H90.4709V53.1275H91.8644V51.7278Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8442 54.7217H83.4507V56.1214H84.8442V54.7217Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 54.7217H85.7913V56.1214H87.1847V54.7217Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5239 54.7217H88.1304V56.1214H89.5239V54.7217Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8644 54.7217H90.4709V56.1214H91.8644V54.7217Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 -1.01562H105.642V0.384119H107.035V-1.01562Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 -1.01562H107.981V0.384119H109.374V-1.01562Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 -1.01562H110.323V0.384119H111.716V-1.01562Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 1.97839H105.642V3.37814H107.035V1.97839Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 1.97839H107.981V3.37814H109.374V1.97839Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 1.97839H110.323V3.37814H111.716V1.97839Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 4.97021H105.642V6.36996H107.035V4.97021Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 4.97046H107.981V6.3702H109.374V4.97046Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 4.97046H110.323V6.3702H111.716V4.97046Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 7.96436H105.642V9.36411H107.035V7.96436Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 7.96436H107.981V9.36411H109.374V7.96436Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 7.96436H110.323V9.36411H111.716V7.96436Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 10.9569H105.642V12.3566H107.035V10.9569Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 10.957H107.981V12.3568H109.374V10.957Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 10.957H110.323V12.3568H111.716V10.957Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 13.9508H105.642V15.3505H107.035V13.9508Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 13.9508H107.981V15.3505H109.374V13.9508Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 13.9508H110.323V15.3505H111.716V13.9508Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 16.9448H105.642V18.3446H107.035V16.9448Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 16.9448H107.981V18.3446H109.374V16.9448Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 16.9448H110.323V18.3446H111.716V16.9448Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 19.9369H105.642V21.3366H107.035V19.9369Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 19.9369H107.981V21.3366H109.374V19.9369Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 19.9369H110.323V21.3366H111.716V19.9369Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 22.9313H105.642V24.331H107.035V22.9313Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 22.9313H107.981V24.331H109.374V22.9313Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 22.9313H110.323V24.331H111.716V22.9313Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 25.9237H105.642V27.3234H107.035V25.9237Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 25.9238H107.981V27.3236H109.374V25.9238Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 25.9238H110.323V27.3236H111.716V25.9238Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 28.9175H105.642V30.3172H107.035V28.9175Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 28.9175H107.981V30.3172H109.374V28.9175Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 28.9175H110.323V30.3172H111.716V28.9175Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 31.9115H105.642V33.3112H107.035V31.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 31.9115H107.981V33.3112H109.374V31.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 31.9115H110.323V33.3112H111.716V31.9115Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 34.9044H105.642V36.3042H107.035V34.9044Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 34.9045H107.981V36.3043H109.374V34.9045Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 34.9045H110.323V36.3043H111.716V34.9045Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 37.8982H105.642V39.2979H107.035V37.8982Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 37.8982H107.981V39.2979H109.374V37.8982Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 37.8982H110.323V39.2979H111.716V37.8982Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 40.8907H105.642V42.2905H107.035V40.8907Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 40.8906H107.981V42.2904H109.374V40.8906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 40.8906H110.323V42.2904H111.716V40.8906Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 43.8848H105.642V45.2845H107.035V43.8848Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 43.8848H107.981V45.2845H109.374V43.8848Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 43.8848H110.323V45.2845H111.716V43.8848Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 46.8771H105.642V48.2768H107.035V46.8771Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 46.877H107.981V48.2767H109.374V46.877Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 46.877H110.323V48.2767H111.716V46.877Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 49.871H105.642V51.2707H107.035V49.871Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 49.8711H107.981V51.2708H109.374V49.8711Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 49.8711H110.323V51.2708H111.716V49.8711Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 52.8656H105.642V54.2653H107.035V52.8656Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 52.8656H107.981V54.2653H109.374V52.8656Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 52.8656H110.323V54.2653H111.716V52.8656Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 19.9369H105.642V21.3366H107.035V19.9369Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.374 19.9369H107.981V21.3366H109.374V19.9369Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.716 19.9369H110.323V21.3366H111.716V19.9369Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.268 46.5875H219.056V94.1591H256.268V46.5875Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 50.0438H226.624V51.6364H228.858V50.0438Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.611 50.0438H230.377V51.6364H232.611V50.0438Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.366 50.0438H234.132V51.6364H236.366V50.0438Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.121 50.0438H237.887V51.6364H240.121V50.0438Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.629 50.0438H245.395V51.6364H247.629V50.0438Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 53.4485H226.624V55.041H228.858V53.4485Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.611 53.4485H230.377V55.041H232.611V53.4485Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.367 53.4485H234.132V55.041H236.367V53.4485Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.121 53.4485H237.887V55.041H240.121V53.4485Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.875 53.4485H241.64V55.041H243.875V53.4485Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.629 53.4485H245.395V55.041H247.629V53.4485Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 56.8518H226.624V58.4444H228.858V56.8518Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.367 56.8517H234.132V58.4442H236.367V56.8517Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.121 56.8517H237.887V58.4442H240.121V56.8517Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.875 56.8517H241.64V58.4442H243.875V56.8517Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 60.256H226.624V61.8485H228.858V60.256Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.611 60.2559H230.377V61.8484H232.611V60.2559Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.875 60.2559H241.64V61.8484H243.875V60.2559Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.629 60.2559H245.395V61.8484H247.629V60.2559Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 63.6606H226.624V65.2532H228.858V63.6606Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.611 63.6608H230.377V65.2533H232.611V63.6608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.121 63.6608H237.887V65.2533H240.121V63.6608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 67.0656H226.624V68.6581H228.858V67.0656Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.611 67.0657H230.377V68.6582H232.611V67.0657Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.121 67.0657H237.887V68.6582H240.121V67.0657Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.875 67.0657H241.64V68.6582H243.875V67.0657Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.629 67.0657H245.395V68.6582H247.629V67.0657Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 70.4686H226.624V72.0612H228.858V70.4686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.611 70.4686H230.377V72.0612H232.611V70.4686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.367 70.4686H234.132V72.0612H236.367V70.4686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.121 70.4686H237.887V72.0612H240.121V70.4686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.875 70.4686H241.64V72.0612H243.875V70.4686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.629 70.4686H245.395V72.0612H247.629V70.4686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 73.8735H226.624V75.4661H228.858V73.8735Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.611 73.8735H230.377V75.4661H232.611V73.8735Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.629 73.8735H245.395V75.4661H247.629V73.8735Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.858 77.278H226.624V78.8705H228.858V77.278Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.611 77.278H230.377V78.8705H232.611V77.278Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.367 77.278H234.132V78.8705H236.367V77.278Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.121 77.278H237.887V78.8705H240.121V77.278Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.875 77.278H241.64V78.8705H243.875V77.278Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.629 77.278H245.395V78.8705H247.629V77.278Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.652 18.5372V12.6294H263.548V18.5372H260.576V94.2216H288.68V18.5372H286.652Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.315 30.7159H275.103V31.2819H276.315V30.7159Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.315 33.2827H275.103V33.8487H276.315V33.2827Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.315 35.8488H275.103V36.4147H276.315V35.8488Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.315 38.4141H275.103V38.98H276.315V38.4141Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82 30.7161H276.608V31.282H277.82V30.7161Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82 33.2827H276.608V33.8487H277.82V33.2827Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82 35.8486H276.608V36.4146H277.82V35.8486Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82 38.4141H276.608V38.98H277.82V38.4141Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.325 30.7157H278.113V31.2817H279.325V30.7157Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.324 33.2823H278.112V33.8483H279.324V33.2823Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.324 35.8485H278.112V36.4145H279.324V35.8485Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.324 38.4136H278.112V38.9795H279.324V38.4136Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.833 30.7161H279.621V31.282H280.833V30.7161Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.833 33.2827H279.621V33.8487H280.833V33.2827Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.833 35.8486H279.621V36.4146H280.833V35.8486Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.608 41.4567H275.396V42.0226H276.608V41.4567Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.338 30.7161H281.126V31.282H282.338V30.7161Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.338 33.2827H281.126V33.8487H282.338V33.2827Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.338 35.8486H281.126V36.4146H282.338V35.8486Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.142 41.7408H281.93V42.3068H283.142V41.7408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.843 30.7161H282.631V31.282H283.843V30.7161Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.843 33.2827H282.631V33.8487H283.843V33.2827Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.843 35.8486H282.631V36.4146H283.843V35.8486Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.843 38.4141H282.631V38.98H283.843V38.4141Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.349 30.7161H284.137V31.282H285.349V30.7161Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35 33.2827H284.138V33.8487H285.35V33.2827Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35 35.8486H284.138V36.4146H285.35V35.8486Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35 38.4141H284.138V38.98H285.35V38.4141Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.315 52.6487H275.103V53.2147H276.315V52.6487Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.315 55.2146H275.103V55.7806H276.315V55.2146Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.315 57.7799H275.103V58.3459H276.315V57.7799Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.315 60.3457H275.103V60.9117H276.315V60.3457Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.722 49.1765H277.51V49.7425H278.722V49.1765Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82 55.215H276.608V55.7809H277.82V55.215Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82 57.7803H276.608V58.3462H277.82V57.7803Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82 60.3461H276.608V60.912H277.82V60.3461Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.325 52.6492H278.113V53.2151H279.325V52.6492Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.325 55.2153H278.113V55.7813H279.325V55.2153Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.325 57.7804H278.113V58.3464H279.325V57.7804Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.325 60.3462H278.113V60.9122H279.325V60.3462Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.833 52.6487H279.621V53.2147H280.833V52.6487Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.833 55.2146H279.621V55.7806H280.833V55.2146Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.833 57.7799H279.621V58.3459H280.833V57.7799Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.833 60.3457H279.621V60.9117H280.833V60.3457Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.833 49.4587H279.621V50.0247H280.833V49.4587Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.338 55.2142H281.126V55.7802H282.338V55.2142Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.338 57.78H281.126V58.346H282.338V57.78Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.338 60.3456H281.126V60.9116H282.338V60.3456Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.843 52.6487H282.631V53.2147H283.843V52.6487Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.843 55.2146H282.631V55.7806H283.843V55.2146Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.843 57.7799H282.631V58.3459H283.843V57.7799Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.843 60.3457H282.631V60.9117H283.843V60.3457Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.349 52.6487H284.137V53.2147H285.349V52.6487Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35 55.2146H284.138V55.7806H285.35V55.2146Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35 57.7799H284.138V58.3459H285.35V57.7799Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35 60.3457H284.138V60.9117H285.35V60.3457Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.119 52.7798H263.907V53.3457H265.119V52.7798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.119 55.3455H263.907V55.9114H265.119V55.3455Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.119 57.9113H263.907V58.4772H265.119V57.9113Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.329 62.6957H264.117V63.2616H265.329V62.6957Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.625 52.7793H265.413V53.3453H266.625V52.7793Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.624 55.345H265.412V55.9109H266.624V55.345Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.624 57.9105H265.412V58.4765H266.624V57.9105Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.871 71.4636H270.658V72.0296H271.871V71.4636Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13 52.7798H266.917V53.3457H268.13V52.7798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13 55.345H266.918V55.9109H268.13V55.345Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13 57.9105H266.918V58.4765H268.13V57.9105Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13 60.4763H266.918V61.0423H268.13V60.4763Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.638 52.7795H268.426V53.3455H269.638V52.7795Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.984 49.3519H272.772V49.9179H273.984V49.3519Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.638 57.9111H268.426V58.4771H269.638V57.9111Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.413 66.4772H264.201V67.0431H265.413V66.4772Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.043 49.3517H270.831V49.9177H272.043V49.3517Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.143 55.3451H269.931V55.9111H271.143V55.3451Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.143 57.9106H269.931V58.4766H271.143V57.9106Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.143 60.4764H269.931V61.0424H271.143V60.4764Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.647 52.7798H271.435V53.3457H272.647V52.7798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.647 55.345H271.435V55.9109H272.647V55.345Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.647 57.9105H271.435V58.4765H272.647V57.9105Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.647 60.4763H271.435V61.0423H272.647V60.4763Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.154 52.7798H272.942V53.3457H274.154V52.7798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.154 55.345H272.942V55.9109H274.154V55.345Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.154 57.9105H272.942V58.4765H274.154V57.9105Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.154 60.4763H272.942V61.0423H274.154V60.4763Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.119 74.7129H263.907V75.2789H265.119V74.7129Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.119 77.2788H263.907V77.8448H265.119V77.2788Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.119 79.8441H263.907V80.4101H265.119V79.8441Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.119 82.4099H263.907V82.9759H265.119V82.4099Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.625 74.7129H265.413V75.2789H266.625V74.7129Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.624 79.8441H265.412V80.4101H266.624V79.8441Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.624 82.4099H265.412V82.9759H266.624V82.4099Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13 74.713H266.918V75.279H268.13V74.713Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.195 71.1801H264.983V71.746H266.195V71.1801Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.408 91.603H266.196V92.169H267.408V91.603Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.955 66.4769H270.743V67.0429H271.955V66.4769Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.638 77.2789H268.426V77.8449H269.638V77.2789Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.638 79.844H268.426V80.41H269.638V79.844Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.638 82.4098H268.426V82.9757H269.638V82.4098Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.143 74.7129H269.931V75.2789H271.143V74.7129Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.143 77.2788H269.931V77.8448H271.143V77.2788Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.442 87.6443H272.23V88.2102H273.442V87.6443Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.647 74.7129H271.435V75.2789H272.647V74.7129Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.647 77.2788H271.435V77.8448H272.647V77.2788Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.647 79.8441H271.435V80.4101H272.647V79.8441Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.647 82.4099H271.435V82.9759H272.647V82.4099Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.154 74.713H272.942V75.279H274.154V74.713Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.072 71.4635H272.86V72.0295H274.072V71.4635Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.154 79.8442H272.942V80.4102H274.154V79.8442Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.154 82.41H272.942V82.976H274.154V82.41Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.688 24.5576H279.9V23.9899H278.688",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.181 24.5576H277.391V23.9899H276.181",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.842 23.9899H280.63V24.5558H281.842V23.9899Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.816 20.5801H274.604V21.146H275.816V20.5801Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.324 20.5802H276.112V21.1462H277.324V20.5802Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.829 20.5802H277.617V21.1462H278.829V20.5802Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.334 20.5802H279.122V21.1462H280.334V20.5802Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.84 20.5802H280.63V21.1462H281.84",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.892 34.177H270.102V33.6111H268.892",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.383 34.177H267.595V33.6111H266.383",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.043 33.6111H270.831V34.177H272.043V33.6111Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.02 30.1998H264.808V30.7658H266.02V30.1998Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.525 30.1998H266.313V30.7658H267.525V30.1998Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.03 30.1998H267.818V30.7658H269.03V30.1998Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.536 30.1998H269.323V30.7658H270.536V30.1998Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.043 30.1998H270.831V30.7658H272.043",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.801 5.03992H153.547V94.2218H187.801V5.03992Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.365 10.9584H154.784V12.3028H157.365V10.9584Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 10.9583H158.955V12.3026H161.537V10.9583Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.709 10.9583H163.128V12.3026H165.709V10.9583Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.879 10.9583H167.298V12.3026H169.879V10.9583Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.051 10.9583H171.47V12.3026H174.051V10.9583Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.223 10.9583H175.642V12.3026H178.223V10.9583Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 10.9583H179.812V12.3026H182.394V10.9583Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 10.9583H183.984V12.3026H186.566V10.9583Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 14.2535H154.784V15.5979H157.366V14.2535Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 14.2535H158.955V15.5979H161.537V14.2535Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 14.2535H163.128V15.5979H165.71V14.2535Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 14.2535H167.298V15.5979H169.88V14.2535Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 14.2535H171.47V15.5979H174.052V14.2535Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 14.2535H175.642V15.5979H178.224V14.2535Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 14.2535H179.812V15.5979H182.394V14.2535Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 14.2535H183.984V15.5979H186.566V14.2535Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 17.5494H154.784V18.8938H157.366V17.5494Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 17.5494H158.955V18.8938H161.537V17.5494Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 17.5494H163.128V18.8938H165.71V17.5494Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 17.5494H167.298V18.8938H169.88V17.5494Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 17.5494H171.47V18.8938H174.052V17.5494Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 17.5494H175.642V18.8938H178.224V17.5494Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 17.5494H179.812V18.8938H182.394V17.5494Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 17.5494H183.984V18.8938H186.566V17.5494Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 20.8456H154.784V22.19H157.366V20.8456Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 20.8455H158.955V22.1899H161.537V20.8455Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 20.8455H163.128V22.1899H165.71V20.8455Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 20.8455H167.298V22.1899H169.88V20.8455Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 20.8455H171.47V22.1899H174.052V20.8455Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 20.8455H175.642V22.1899H178.224V20.8455Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 20.8455H179.812V22.1899H182.394V20.8455Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 20.8455H183.984V22.1899H186.566V20.8455Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 24.1415H154.784V25.4859H157.366V24.1415Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 24.1415H158.955V25.4859H161.537V24.1415Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 24.1415H163.128V25.4859H165.71V24.1415Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 24.1415H167.298V25.4859H169.88V24.1415Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 24.1415H171.47V25.4859H174.052V24.1415Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 24.1415H175.642V25.4859H178.224V24.1415Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 24.1415H179.812V25.4859H182.394V24.1415Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 24.1415H183.984V25.4859H186.566V24.1415Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 27.4354H154.784V28.7798H157.366V27.4354Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 27.4353H158.955V28.7797H161.537V27.4353Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 27.4353H163.128V28.7797H165.71V27.4353Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 27.4353H167.298V28.7797H169.88V27.4353Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 27.4353H171.47V28.7797H174.052V27.4353Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 27.4353H175.642V28.7797H178.224V27.4353Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 27.4353H179.812V28.7797H182.394V27.4353Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 27.4353H183.984V28.7797H186.566V27.4353Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 30.7311H154.784V32.0755H157.366V30.7311Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 30.7311H158.955V32.0755H161.537V30.7311Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 30.7311H163.128V32.0755H165.71V30.7311Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 30.7311H167.298V32.0755H169.88V30.7311Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 30.7311H171.47V32.0755H174.052V30.7311Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 30.7311H175.642V32.0755H178.224V30.7311Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 30.7311H179.812V32.0755H182.394V30.7311Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 30.7311H183.984V32.0755H186.566V30.7311Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 34.0267H154.784V35.3711H157.366V34.0267Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 34.0267H158.955V35.3711H161.537V34.0267Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 34.0267H163.128V35.3711H165.71V34.0267Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 34.0267H167.298V35.3711H169.88V34.0267Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 34.0267H171.47V35.3711H174.052V34.0267Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 34.0267H175.642V35.3711H178.224V34.0267Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 34.0267H179.812V35.3711H182.394V34.0267Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 34.0267H183.984V35.3711H186.566V34.0267Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 37.3229H154.784V38.6673H157.366V37.3229Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 37.3228H158.955V38.6672H161.537V37.3228Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 37.3228H163.128V38.6672H165.71V37.3228Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 37.3228H167.298V38.6672H169.88V37.3228Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 37.3228H171.47V38.6672H174.052V37.3228Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 37.3228H175.642V38.6672H178.224V37.3228Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 37.3228H179.812V38.6672H182.394V37.3228Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 37.3228H183.984V38.6672H186.566V37.3228Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 40.6188H154.784V41.9632H157.366V40.6188Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 40.6189H158.955V41.9633H161.537V40.6189Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 40.6189H163.128V41.9633H165.71V40.6189Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 40.6189H167.298V41.9633H169.88V40.6189Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 40.6189H171.47V41.9633H174.052V40.6189Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 40.6189H175.642V41.9633H178.224V40.6189Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 40.6189H179.812V41.9633H182.394V40.6189Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 40.6189H183.984V41.9633H186.566V40.6189Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 43.9147H154.784V45.2591H157.366V43.9147Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 43.9147H158.955V45.2591H161.537V43.9147Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 43.9147H163.128V45.2591H165.71V43.9147Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 43.9147H167.298V45.2591H169.88V43.9147Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 43.9147H171.47V45.2591H174.052V43.9147Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 43.9147H175.642V45.2591H178.224V43.9147Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 43.9147H179.812V45.2591H182.394V43.9147Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 43.9147H183.984V45.2591H186.566V43.9147Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 47.2102H154.784V48.5546H157.366V47.2102Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 47.2101H158.955V48.5545H161.537V47.2101Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 47.2101H163.128V48.5545H165.71V47.2101Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 47.2101H167.298V48.5545H169.88V47.2101Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 47.2101H171.47V48.5545H174.052V47.2101Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 47.2101H175.642V48.5545H178.224V47.2101Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 47.2101H179.812V48.5545H182.394V47.2101Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 47.2101H183.984V48.5545H186.566V47.2101Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 50.5043H154.784V51.8487H157.366V50.5043Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 50.5043H158.955V51.8487H161.537V50.5043Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 50.5043H163.128V51.8487H165.71V50.5043Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 50.5043H167.298V51.8487H169.88V50.5043Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 50.5043H171.47V51.8487H174.052V50.5043Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 50.5043H175.642V51.8487H178.224V50.5043Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 50.5043H179.812V51.8487H182.394V50.5043Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 50.5043H183.984V51.8487H186.566V50.5043Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 53.8007H154.784V55.1451H157.366V53.8007Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 53.8007H158.955V55.1451H161.537V53.8007Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 53.8007H163.128V55.1451H165.71V53.8007Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 53.8007H167.298V55.1451H169.88V53.8007Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 53.8007H171.47V55.1451H174.052V53.8007Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 53.8007H175.642V55.1451H178.224V53.8007Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 53.8007H179.812V55.1451H182.394V53.8007Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 53.8007H183.984V55.1451H186.566V53.8007Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 57.0962H154.784V58.4406H157.366V57.0962Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 57.0963H158.955V58.4407H161.537V57.0963Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 57.0963H163.128V58.4407H165.71V57.0963Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 57.0963H167.298V58.4407H169.88V57.0963Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 57.0963H171.47V58.4407H174.052V57.0963Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 57.0963H175.642V58.4407H178.224V57.0963Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 57.0963H179.812V58.4407H182.394V57.0963Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 57.0963H183.984V58.4407H186.566V57.0963Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 60.3916H154.784V61.736H157.366V60.3916Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 60.3916H158.955V61.736H161.537V60.3916Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 60.3916H163.128V61.736H165.71V60.3916Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 60.3916H167.298V61.736H169.88V60.3916Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 60.3916H171.47V61.736H174.052V60.3916Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 60.3916H175.642V61.736H178.224V60.3916Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 60.3916H179.812V61.736H182.394V60.3916Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 60.3916H183.984V61.736H186.566V60.3916Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 63.6877H154.784V65.0321H157.366V63.6877Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 63.6877H158.955V65.0321H161.537V63.6877Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 63.6877H163.128V65.0321H165.71V63.6877Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 63.6877H167.298V65.0321H169.88V63.6877Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 63.6877H171.47V65.0321H174.052V63.6877Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 63.6877H175.642V65.0321H178.224V63.6877Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 63.6877H179.812V65.0321H182.394V63.6877Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 63.6877H183.984V65.0321H186.566V63.6877Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 66.9832H154.784V68.3276H157.366V66.9832Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 66.9833H158.955V68.3277H161.537V66.9833Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 66.9833H163.128V68.3277H165.71V66.9833Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 66.9833H167.298V68.3277H169.88V66.9833Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 66.9833H171.47V68.3277H174.052V66.9833Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 66.9833H175.642V68.3277H178.224V66.9833Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 66.9833H179.812V68.3277H182.394V66.9833Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 66.9833H183.984V68.3277H186.566V66.9833Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 70.2798H154.784V71.6242H157.366V70.2798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 70.2798H158.955V71.6242H161.537V70.2798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 70.2798H163.128V71.6242H165.71V70.2798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 70.2798H167.298V71.6242H169.88V70.2798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 70.2798H171.47V71.6242H174.052V70.2798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 70.2798H175.642V71.6242H178.224V70.2798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 70.2798H179.812V71.6242H182.394V70.2798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 70.2798H183.984V71.6242H186.566V70.2798Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 73.5752H154.784V74.9196H157.366V73.5752Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 73.5752H158.955V74.9196H161.537V73.5752Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 73.5752H163.128V74.9196H165.71V73.5752Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 73.5752H167.298V74.9196H169.88V73.5752Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 73.5752H171.47V74.9196H174.052V73.5752Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 73.5752H175.642V74.9196H178.224V73.5752Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 73.5752H179.812V74.9196H182.394V73.5752Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 73.5752H183.984V74.9196H186.566V73.5752Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 76.8691H154.784V78.2135H157.366V76.8691Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 76.8691H158.955V78.2135H161.537V76.8691Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 76.8691H163.128V78.2135H165.71V76.8691Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 76.8691H167.298V78.2135H169.88V76.8691Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 76.8691H171.47V78.2135H174.052V76.8691Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 76.8691H175.642V78.2135H178.224V76.8691Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 76.8691H179.812V78.2135H182.394V76.8691Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 76.8691H183.984V78.2135H186.566V76.8691Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 80.1648H154.784V81.5092H157.366V80.1648Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 80.1648H158.955V81.5092H161.537V80.1648Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 80.1648H163.128V81.5092H165.71V80.1648Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 80.1648H167.298V81.5092H169.88V80.1648Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 80.1648H171.47V81.5092H174.052V80.1648Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 80.1648H175.642V81.5092H178.224V80.1648Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 80.1648H179.812V81.5092H182.394V80.1648Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 80.1648H183.984V81.5092H186.566V80.1648Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 83.4609H154.784V84.8053H157.366V83.4609Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 83.4608H158.955V84.8052H161.537V83.4608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 83.4608H163.128V84.8052H165.71V83.4608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 83.4608H167.298V84.8052H169.88V83.4608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 83.4608H171.47V84.8052H174.052V83.4608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 83.4608H175.642V84.8052H178.224V83.4608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 83.4608H179.812V84.8052H182.394V83.4608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 83.4608H183.984V84.8052H186.566V83.4608Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.366 86.7568H154.784V88.1012H157.366V86.7568Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 86.7568H158.955V88.1012H161.537V86.7568Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71 86.7568H163.128V88.1012H165.71V86.7568Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88 86.7568H167.298V88.1012H169.88V86.7568Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 86.7568H171.47V88.1012H174.052V86.7568Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 86.7568H175.642V88.1012H178.224V86.7568Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.394 86.7568H179.812V88.1012H182.394V86.7568Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 86.7568H183.984V88.1012H186.566V86.7568Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.679 -35.3149H191.244V94.222H216.679V-35.3149Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 -1.25195H192.096V0.728042H203.132V-1.25195Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 -1.25183H204.789V0.728164H215.825V-1.25183Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 3.95264H192.096V5.93263H203.132V3.95264Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 3.95276H204.789V5.93275H215.825V3.95276Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 9.15869H192.096V11.1387H203.132V9.15869Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 9.15857H204.789V11.1386H215.825V9.15857Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 14.3651H192.096V16.3451H203.132V14.3651Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 14.3651H204.789V16.3451H215.825V14.3651Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 19.5695H192.096V21.5495H203.132V19.5695Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 19.5695H204.789V21.5495H215.825V19.5695Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 24.7758H192.096V26.7558H203.132V24.7758Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 24.7758H204.789V26.7558H215.825V24.7758Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 29.9818H192.096V31.9618H203.132V29.9818Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 29.9818H204.789V31.9618H215.825V29.9818Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 35.1859H192.096V37.1659H203.132V35.1859Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 35.1859H204.789V37.1659H215.825V35.1859Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 40.3922H192.096V42.3722H203.132V40.3922Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 40.3923H204.789V42.3723H215.825V40.3923Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 45.5968H192.096V47.5768H203.132V45.5968Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 45.5968H204.789V47.5768H215.825V45.5968Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 50.8029H192.096V52.7829H203.132V50.8029Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 50.803H204.789V52.783H215.825V50.803Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 56.0092H192.096V57.9892H203.132V56.0092Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 56.009H204.789V57.989H215.825V56.009Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 61.2137H192.096V63.1937H203.132V61.2137Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 61.2136H204.789V63.1936H215.825V61.2136Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 66.4198H192.096V68.3998H203.132V66.4198Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 66.4198H204.789V68.3998H215.825V66.4198Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 71.6257H192.096V73.6057H203.132V71.6257Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 71.6257H204.789V73.6057H215.825V71.6257Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 76.8303H192.096V78.8103H203.132V76.8303Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 76.8303H204.789V78.8103H215.825V76.8303Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 82.0364H192.096V84.0164H203.132V82.0364Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 82.0364H204.789V84.0164H215.825V82.0364Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.132 87.2424H192.096V89.2224H203.132V87.2424Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.825 87.2426H204.789V89.2225H215.825V87.2426Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.041 51.4387H86.9822V94.2219H110.041V51.4387Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.482 49.2887V46.5731H97.9301V49.2887H90.7169V51.4383H108.322V49.2887H102.482Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.041 53.8716H86.9822V55.7391H110.041V53.8716Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.041 59.4722H86.9822V61.3397H110.041V59.4722Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7606 62.8113H87.7554V65.3572H97.7606V62.8113Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.268 62.8114H99.2627V65.3574H109.268V62.8114Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7606 68.5833H87.7554V70.5632H97.7606V68.5833Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.268 68.5831H99.2627V70.5631H109.268V68.5831Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7607 75.0891H87.7554V77.0691H97.7607V75.0891Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.268 75.0892H99.2628V77.0692H109.268V75.0892Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7609 80.2953H87.7557V82.2753H97.7609V80.2953Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.269 80.2952H99.2634V82.2752H109.269V80.2952Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7609 85.5H87.7557V87.48H97.7609V85.5Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.269 85.5001H99.2634V87.4801H109.269V85.5001Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8611 17.6128V6.10418H39.1208V-9.28942H41.9434V-34.7258H62.5285V-9.18944H65.0053V6.10418H66.9158V94.3576H36.8611V17.6128Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3568 -8.84473H45.1413V14.1368H46.3568V-8.84473Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5995 -8.84473H48.384V14.1368H49.5995V-8.84473Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.843 -8.84473H51.6276V14.1368H52.843V-8.84473Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0854 -8.84473H54.8699V14.1368H56.0854V-8.84473Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3281 -8.84473H58.1126V14.1368H59.3281V-8.84473Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9176 5.77026H61.7021V14.1366H62.9176V5.77026Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4617 5.77026H42.2462V14.1366H43.4617V5.77026Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3568 15.1685H45.1414V43.8453H46.3568V15.1685Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5995 15.1685H48.384V43.8453H49.5995V15.1685Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8431 15.1685H51.6276V43.8453H52.8431V15.1685Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0854 15.1685H54.8699V43.8453H56.0854V15.1685Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3281 15.1685H58.1126V43.8453H59.3281V15.1685Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9177 15.1685H61.7022V43.8453H62.9177V15.1685Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4621 15.1686H42.2466V43.8455H43.4621V15.1686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.657 80.3938V32.1741H132.692L139.027 33.9898H139.934V44.2344H142.589V94.2216H119.657V80.3938Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.075 36.1305H120.576V41.1617H122.075V36.1305Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.982 36.1305H122.483V41.1617H123.982V36.1305Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.962 36.1305H125.463V41.1617H126.962V36.1305Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.869 36.1305H127.371V41.1617H128.869V36.1305Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85 36.1305H130.351V41.1617H131.85V36.1305Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.758 36.1305H132.26V41.1617H133.758V36.1305Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.075 45.5341H120.576V50.5653H122.075V45.5341Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.982 45.5342H122.483V50.5654H123.982V45.5342Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.962 45.5342H125.463V50.5654H126.962V45.5342Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.869 45.5343H127.371V50.5655H128.869V45.5343Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.075 54.9392H120.576V59.9704H122.075V54.9392Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.982 54.9391H122.483V59.9703H123.982V54.9391Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.962 54.9391H125.463V59.9703H126.962V54.9391Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.869 54.9391H127.371V59.9703H128.869V54.9391Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85 54.9391H130.351V59.9703H131.85V54.9391Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.758 54.9391H132.26V59.9703H133.758V54.9391Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.738 54.9391H135.24V59.9703H136.738V54.9391Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.645 54.9391H137.147V59.9703H138.645V54.9391Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.075 64.3433H120.576V69.3745H122.075V64.3433Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.982 64.3433H122.483V69.3745H123.982V64.3433Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.962 64.3433H125.463V69.3745H126.962V64.3433Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.869 64.3433H127.371V69.3745H128.869V64.3433Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85 64.3433H130.351V69.3745H131.85V64.3433Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.758 64.3433H132.26V69.3745H133.758V64.3433Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.738 64.3433H135.24V69.3745H136.738V64.3433Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.645 64.3433H137.147V69.3745H138.645V64.3433Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.075 73.7465H120.576V78.7777H122.075V73.7465Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.982 73.7465H122.483V78.7777H123.982V73.7465Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.962 73.7465H125.463V78.7777H126.962V73.7465Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.869 73.7465H127.371V78.7777H128.869V73.7465Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85 73.7465H130.351V78.7777H131.85V73.7465Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.758 73.7465H132.26V78.7777H133.758V73.7465Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.738 73.7465H135.24V78.7777H136.738V73.7465Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.645 73.7465H137.147V78.7777H138.645V73.7465Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.075 83.1517H120.576V88.183H122.075V83.1517Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.982 83.1519H122.483V88.1831H123.982V83.1519Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.962 83.1519H125.463V88.1831H126.962V83.1519Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.869 83.152H127.371V88.1832H128.869V83.152Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.738 83.1519H135.24V88.1831H136.738V83.1519Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.645 83.152H137.147V88.1832H138.645V83.152Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.2216 46.5733H-12.2495V58.1605H-1.26784V44.9451H11.465V94.1592H-17.2386L-17.2216 46.5733Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.127 76.4609C404.347 75.7289 402.754 76.5502 402.567 76.6573C402.466 76.5502 400.737 75.2469 398.601 75.8896C397.753 76.1396 397.143 76.6038 396.719 77.068C396.193 76.6573 395.532 76.3895 394.837 76.3538C393.888 76.3181 393.006 76.7109 392.379 77.3715C392.227 77.3893 392.074 77.425 391.921 77.4607C391.854 77.1394 391.701 76.7287 391.26 76.4074C390.616 75.9253 389.667 75.8539 388.853 76.2467C388.768 75.9967 388.022 74.1399 385.768 73.3901C383.666 72.6938 381.869 73.4972 381.581 73.6222C380.665 72.6938 379.275 72.2831 377.936 72.5331C376.512 72.8009 375.376 73.7829 375.02 75.0326C374.986 74.9434 374.274 72.9437 371.952 72.4438C370.426 72.1046 368.799 72.5688 367.748 73.6222C367.629 73.515 366.696 72.7116 365.289 72.8187C363.967 72.9259 363.221 73.765 363.103 73.9078C362.696 73.7829 362.001 73.64 361.136 73.7114C359.882 73.8364 359 74.3542 358.627 74.6041C358.509 74.5684 357.644 74.2828 356.762 74.7113C356.033 75.0683 355.796 75.6754 355.745 75.8182C355.542 75.7111 355.203 75.5504 354.813 75.4254C354.66 75.0683 354.457 74.7291 354.169 74.4613C353.169 73.4972 351.745 73.6579 351.558 73.6757C351.49 73.4793 350.999 71.8903 349.27 71.194C347.473 70.462 345.879 71.3012 345.71 71.3904C345.574 71.3012 343.862 69.98 341.726 70.6227C341.251 70.7655 340.827 70.9977 340.505 71.2298C339.522 70.5156 338.335 70.6227 338.166 70.6406C338.098 70.4442 337.606 68.8552 335.86 68.1589C334.063 67.4269 332.487 68.2482 332.3 68.3553C332.165 68.2482 330.452 66.9627 328.316 67.5697C326.452 68.1589 325.757 69.7479 325.655 69.9443C325.316 69.73 323.977 68.8909 322.129 69.0516C321.485 69.123 320.942 69.3015 320.485 69.5336C319.722 69.6408 319.196 69.9086 319.078 69.9621C318.976 69.8729 317.247 68.5695 315.111 69.2123C313.246 69.7657 312.534 71.3547 312.449 71.5868C312.093 71.3369 310.771 70.4977 308.906 70.6941C306.838 70.8727 305.634 72.2117 305.38 72.4795C304.566 71.8903 303.414 71.8903 302.6 72.5152C302.007 73.0151 301.735 73.765 301.871 74.4792C301.735 74.5684 301.6 74.6577 301.498 74.747C301.006 74.497 300.447 74.4434 299.955 74.6041C299.379 74.7827 298.972 75.2469 298.769 75.7825C298.311 75.9075 297.904 76.1931 297.616 76.5681C297.277 77.0323 297.192 77.5857 297.277 78.1213C296.955 77.5679 296.378 76.8537 295.361 76.4609C293.581 75.7289 291.988 76.5502 291.801 76.6573C291.7 76.5502 289.987 75.2469 287.851 75.8896C285.97 76.4431 285.258 78.0321 285.173 78.2463C284.817 78.0321 283.495 77.1929 281.63 77.3536C280.986 77.425 280.46 77.6214 279.986 77.8357C279.223 77.9428 278.697 78.2285 278.612 78.2642C278.477 78.1749 276.765 76.8716 274.612 77.5143C272.747 78.0678 272.035 79.6568 271.95 79.871C271.611 79.6568 270.272 78.7998 268.424 78.9783C266.339 79.1747 265.135 80.5138 264.881 80.7994C264.084 80.1745 262.915 80.1924 262.135 80.8173C261.508 81.3172 261.236 82.067 261.372 82.799C261.253 82.8705 261.101 82.9597 261.016 83.049C260.524 82.799 259.965 82.7455 259.456 82.9062C259.185 82.9955 258.965 83.1383 258.761 83.3347C258.626 83.1204 258.473 82.924 258.304 82.7455C257.27 81.7992 255.879 81.9599 255.693 81.9778C255.625 81.7814 255.134 80.1924 253.387 79.4782C251.591 78.7641 250.014 79.6032 249.844 79.6746C249.709 79.6032 247.997 78.282 245.861 78.9248C245.369 79.0854 244.962 79.2997 244.623 79.5318C243.657 78.8176 242.453 78.9248 242.267 78.9426C242.233 78.7462 241.707 77.1394 239.978 76.4609C238.198 75.7289 236.622 76.5502 236.435 76.6573C236.3 76.5502 234.587 75.2469 232.451 75.8896C230.587 76.4431 229.875 78.0321 229.773 78.2463C229.451 78.0321 228.112 77.1929 226.264 77.3536C225.62 77.425 225.077 77.6214 224.586 77.8357C223.857 77.9428 223.331 78.2285 223.212 78.2642C223.077 78.1749 221.365 76.8716 219.229 77.5143C217.364 78.0678 216.669 79.6568 216.55 79.871C216.228 79.6568 214.889 78.7998 213.041 78.9783C210.939 79.1747 209.735 80.5138 209.515 80.7994C208.701 80.1745 207.532 80.1924 206.735 80.8173C206.141 81.3172 205.853 82.067 205.972 82.799C205.87 82.8705 205.735 82.9597 205.616 83.049C205.141 82.799 204.582 82.7455 204.056 82.9062C203.802 82.9955 203.582 83.1383 203.395 83.3347C203.26 83.1204 203.107 82.924 202.937 82.7455C201.903 81.7992 200.496 81.9599 200.31 81.9778C200.242 81.7814 199.75 80.1924 198.004 79.4782C196.224 78.7641 194.631 79.6032 194.444 79.6746C194.343 79.6032 192.614 78.282 190.478 78.9248C189.986 79.0854 189.596 79.2997 189.24 79.5318C188.257 78.8176 187.07 78.9248 186.901 78.9426C186.833 78.7462 186.341 77.1394 184.612 76.4609C182.832 75.7289 181.222 76.5502 181.052 76.6573C180.933 76.5502 179.221 75.2469 177.085 75.8896C175.204 76.4431 174.492 78.0321 174.407 78.2463C174.051 78.0321 172.745 77.1929 170.864 77.3536C170.22 77.425 169.694 77.6214 169.219 77.8357C168.457 77.9428 167.931 78.2285 167.846 78.2642C167.745 78.2106 167.083 77.7107 166.1 77.4607C165.744 77.068 165.286 76.6752 164.608 76.4074C162.828 75.6754 161.235 76.4966 161.048 76.6038C160.947 76.4966 159.218 75.2112 157.082 75.8539C156.59 75.9789 156.2 76.211 155.844 76.4609C154.861 75.7468 153.674 75.836 153.505 75.8718C153.437 75.6575 152.945 74.0685 151.216 73.3544C149.436 72.6402 147.826 73.4793 147.656 73.5686C147.537 73.4615 145.825 72.176 143.689 72.8009C141.808 73.3544 141.096 74.9612 141.011 75.1755C140.655 74.9434 139.35 74.1042 137.468 74.2828C136.824 74.3542 136.298 74.5327 135.823 74.7648C135.061 74.8541 134.535 75.1219 134.45 75.1933C134.315 75.0862 132.602 73.7829 130.467 74.4256C129.212 74.7827 128.5 75.6218 128.127 76.1931C127.619 76.1396 127.144 76.1931 126.737 76.2645C126.127 76.0146 125.296 75.8003 124.279 75.9075H124.177C123.499 75.7111 122.652 75.6218 121.685 75.8896C120.685 76.1931 120.041 76.7823 119.617 77.3001C119.397 77.2643 119.159 77.3001 118.939 77.3358C118.396 76.6038 117.617 76.1396 116.769 76.1039C115.735 76.0503 114.735 76.693 114.125 77.7286C114.057 77.7464 113.989 77.7643 113.921 77.8C113.887 77.425 113.769 76.693 113.209 76.1574C112.565 75.5504 111.599 75.4611 110.802 75.9432C110.717 75.6397 109.971 73.2294 107.717 72.2653C105.614 71.3904 103.818 72.4081 103.529 72.5688C102.614 71.3904 101.224 70.8548 99.8846 71.1762C98.4606 71.5154 97.3248 72.783 96.9688 74.4077C96.9349 74.2828 96.2229 71.7118 93.9005 71.0512C92.3748 70.6227 90.7473 71.2119 89.6963 72.5688C89.5776 72.4438 88.6453 71.4083 87.2382 71.5511C85.899 71.6761 85.17 72.7652 85.0514 72.9437C84.6445 72.783 83.9495 72.6045 83.0849 72.6938C81.8304 72.8366 80.9489 73.5329 80.576 73.8543C80.4573 73.8007 79.5927 73.4258 78.7112 73.9792C77.9823 74.4256 77.7449 75.229 77.6941 75.4076C77.2194 75.0683 76.2362 74.5149 74.9309 74.5149C73.1678 74.5327 71.8795 75.5861 71.2014 76.3181C70.7437 76.4252 70.4216 76.5859 70.3198 76.6395C69.6926 76.1217 68.3195 75.1933 66.5056 75.4968C64.7426 75.7825 63.6406 77.0501 63.0643 77.9428C62.7422 77.7821 62.3184 77.6214 61.7929 77.4964C61.4538 77.3715 61.0978 77.2822 60.7249 77.2644C60.2841 77.2465 59.8772 77.3358 59.4704 77.4964C59.1144 77.5857 58.7584 77.6928 58.4533 77.8357C58.1651 77.8714 57.9108 77.9428 57.6904 78.0142C57.5887 77.7821 57.4361 77.5322 57.1479 77.3001C56.5037 76.8359 55.5544 76.7644 54.7577 77.1394C54.6559 76.9073 53.927 75.0326 51.6554 74.2828C49.5703 73.5865 47.7564 74.3899 47.4682 74.5149C46.5528 73.6043 45.1627 73.1937 43.8234 73.4436C42.3995 73.6936 41.2637 74.6755 40.9246 75.9432C40.8907 75.8539 40.1618 73.8364 37.8562 73.3365C36.3136 73.0151 34.6862 73.4615 33.6351 74.5149C33.5165 74.4077 32.601 73.6043 31.194 73.7114C29.8548 73.8186 29.1089 74.6755 29.0072 74.8005C28.5833 74.6934 27.8883 74.5327 27.0237 74.622C25.7693 74.7291 24.8878 75.2647 24.5318 75.5147C24.4131 75.479 23.5316 75.1755 22.6501 75.6039C22.4297 75.7289 22.2601 75.8539 22.1245 75.9967C21.4464 75.8182 20.8701 75.836 20.7514 75.8718C20.7005 75.6575 20.192 74.0685 18.4459 73.3544C16.6659 72.6402 15.0893 73.4793 14.9029 73.5686C14.7842 73.4615 13.0551 72.176 10.9191 72.8009C9.05433 73.3544 8.34233 74.9612 8.25757 75.1755C7.91853 74.9434 6.5793 74.1042 4.7315 74.2828C4.08731 74.3542 3.56179 74.5327 3.07018 74.7648C2.32428 74.8541 1.79876 75.1219 1.68009 75.1933C1.54447 75.0862 -0.167707 73.7829 -2.30369 74.4256C-4.16844 74.9791 -4.86349 76.5681 -4.9652 76.7823C-5.30425 76.5502 -6.64348 75.7289 -8.49127 75.9075C-10.5764 76.1038 -11.78 77.4429 -12.0004 77.7107C-12.8311 77.0858 -13.9838 77.1037 -14.7975 77.7286C-15.3908 78.2285 -15.679 78.9962 -15.5434 79.7103C-15.6621 79.7996 -15.7977 79.871 -15.8994 79.9424C-16.3232 79.746 -16.7979 79.6568 -17.2386 79.7639V94.2255H406.568V76.6573C406.433 76.5859 406.28 76.5145 406.127 76.4609ZM369.527 83.3347C369.527 83.3347 369.527 83.3347 369.527 83.3168H369.544C369.527 83.3347 369.527 83.3347 369.527 83.3347Z",
    fill: "#055E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.414 68.3016C261.465 69.6085 259.49 70.0602 257.828 69.1729C257.774 69.2996 257.123 70.6547 255.65 70.9083C254.662 71.0743 253.894 70.6476 253.667 70.5119C252.483 71.3832 251.025 71.4224 250.139 70.7012C249.527 70.2102 249.356 69.4889 249.3 69.18C249.135 69.3389 248.789 69.6317 248.257 69.7906C247.669 69.9567 247.176 69.8692 246.955 69.8138C246.155 71.7706 244.228 72.965 242.251 72.7829C240.573 72.624 239.099 71.4921 238.433 69.8602C236.874 69.0764 235.877 67.5089 235.807 65.8056V65.7985C235.792 65.5521 235.799 65.3075 235.831 65.0611C236.058 63.1597 237.414 61.5689 239.264 61.0529C239.232 60.8708 238.935 58.7962 240.486 57.2911C241.914 55.9057 243.731 56.1181 243.966 56.1503C244.304 53.5454 246.326 51.6368 248.569 51.5493C251.156 51.4458 252.716 53.815 252.787 53.9257C254.457 52.7295 256.786 53.0865 258.032 54.7184C258.205 54.9398 258.345 55.1862 258.462 55.4308C259.168 56.968 258.815 58.8605 257.491 60.0085C258.479 59.6353 259.591 59.8585 260.329 60.578C261.332 61.56 261.112 62.9222 261.09 63.0329C263.08 64.1827 263.55 66.7483 262.414 68.3016Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.495 65.0373C258.549 65.2837 258.667 65.9408 258.306 66.4942C257.796 67.2869 256.503 67.5708 255.257 66.9691C253.814 67.7761 252.144 67.7618 250.985 66.9066C250.169 66.3121 249.84 65.473 249.715 65.0695C249.7 65.1016 249.378 65.664 248.735 65.6872C248.21 65.7104 247.872 65.3462 247.826 65.2909C247.779 65.5837 247.63 66.3675 246.987 67.0727C246.321 67.8083 245.529 68.0225 245.246 68.0868C245.216 68.1421 244.745 69.0295 243.756 69.1169C243.012 69.1884 242.29 68.7759 241.937 68.0868C241.615 68.7759 240.981 69.2437 240.306 69.2509C239.381 69.2669 238.481 68.4028 238.433 67.2244C238.347 67.2726 237.65 67.6762 236.88 67.3584C236.268 67.1048 235.846 66.496 235.807 65.8068V65.7997C235.792 65.5533 235.799 65.3087 235.831 65.0623C236.058 63.1609 237.414 61.5701 239.264 61.0541C239.232 60.872 238.935 58.7974 240.486 57.2923C241.913 55.9069 243.731 56.1193 243.966 56.1515C244.304 53.5466 246.326 51.638 248.569 51.5505C251.156 51.447 252.715 53.8162 252.787 53.9269C254.456 52.7307 256.786 53.0878 258.032 54.7196C258.205 54.941 258.345 55.1874 258.462 55.432C258.133 55.5516 257.766 55.6373 257.365 55.6855C256.621 55.773 255.979 55.6694 255.531 55.5587C255.665 55.6855 255.947 55.9944 256.072 56.4782C256.269 57.2781 255.836 57.9279 255.758 58.0297C255.986 58.26 256.706 59.0509 256.825 60.3114C256.926 61.3577 256.559 62.1486 256.394 62.4503C257.398 62.0861 258.425 62.5289 258.761 63.3055C258.996 63.8411 258.878 64.5142 258.495 65.0373Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.009 93.1308H248.8L248.99 75.7286V75.4287L249.032 72.1329V71.8115L249.053 69.3709L249.095 66.9303V65.6037L249.158 60.2958V59.9315L249.2 56.1429C249.2 56.0358 249.285 55.9287 249.412 55.9287C249.517 55.9501 249.624 56.0358 249.624 56.1429L249.687 63.0578V63.3363L249.709 65.0913L249.729 67.5534L249.751 67.8533L249.772 70.3154L249.792 73.7611L249.812 74.0397L250.009 93.1308Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41 63.5305C249.374 63.5305 249.339 63.5145 249.315 63.4823C249.276 63.4288 249.288 63.3556 249.34 63.3163L255.572 58.6957C255.625 58.6564 255.699 58.6672 255.736 58.7207C255.775 58.7743 255.764 58.8475 255.711 58.8868L249.479 63.5073C249.459 63.5234 249.435 63.5305 249.41 63.5305Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.411 60.56C249.375 60.56 249.34 60.5439 249.318 60.5118L246.143 56.2215C246.104 56.1697 246.114 56.0947 246.166 56.0555C246.219 56.0162 246.292 56.0269 246.331 56.0787L249.506 60.369C249.545 60.4207 249.535 60.4957 249.482 60.535C249.46 60.5528 249.436 60.56 249.411 60.56Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41 67.2264C249.38 67.2264 249.349 67.2139 249.325 67.1907L242.885 60.524C242.84 60.4776 242.841 60.4026 242.887 60.3562C242.933 60.3098 243.007 60.3116 243.053 60.358L249.493 67.0246C249.539 67.071 249.537 67.146 249.492 67.1925C249.47 67.2157 249.441 67.2264 249.41 67.2264Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.411 68.0838C249.375 68.0838 249.341 68.0677 249.317 68.0374C249.278 67.9856 249.289 67.9106 249.339 67.8713L256.878 62.0795C256.929 62.0403 257.004 62.0492 257.042 62.1028C257.081 62.1545 257.071 62.2295 257.02 62.2688L249.482 68.0606C249.461 68.0767 249.436 68.0838 249.411 68.0838Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41 72.4396C249.381 72.4396 249.353 72.4289 249.331 72.4075L240.995 64.6197C240.948 64.575 240.944 64.5 240.988 64.4518C241.034 64.4036 241.107 64.4001 241.155 64.4447L249.49 72.2325C249.537 72.2772 249.541 72.3522 249.497 72.4004C249.473 72.4272 249.442 72.4396 249.41 72.4396Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41 74.2875C249.372 74.2875 249.335 74.2697 249.313 74.2358C249.276 74.1804 249.291 74.1072 249.345 74.0715L258.388 67.8673C258.44 67.8316 258.513 67.8441 258.55 67.8994C258.588 67.9548 258.572 68.028 258.52 68.0637L249.477 74.2679C249.457 74.2804 249.433 74.2875 249.41 74.2875Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41 75.9378C249.39 75.9378 249.371 75.9325 249.353 75.9235L241.997 71.7654C241.939 71.7332 241.921 71.6618 241.951 71.6029C241.983 71.5458 242.055 71.5261 242.111 71.5583L249.466 75.7164C249.522 75.7486 249.542 75.8218 249.512 75.8771C249.492 75.9164 249.453 75.9378 249.41 75.9378Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.241 72.3308C169.446 73.4252 167.792 73.8037 166.4 73.061C166.354 73.1681 165.808 74.3018 164.574 74.5143C163.747 74.6535 163.103 74.2947 162.913 74.1822C161.921 74.9124 160.699 74.9446 159.958 74.3411C159.446 73.9305 159.302 73.3252 159.256 73.0663C159.119 73.1985 158.829 73.4448 158.383 73.577C157.89 73.7162 157.476 73.643 157.293 73.5966C156.623 75.2356 155.008 76.2372 153.353 76.0836C151.948 75.9515 150.714 75.0017 150.156 73.6359C148.849 72.9789 148.015 71.6648 147.956 70.2383V70.2311C147.942 70.0258 147.949 69.8205 147.976 69.6152C148.166 68.0226 149.303 66.6889 150.853 66.2587C150.826 66.1069 150.577 64.3679 151.877 63.1075C153.072 61.947 154.596 62.1255 154.793 62.1523C155.076 59.9687 156.769 58.3708 158.648 58.2976C160.814 58.2119 162.121 60.1955 162.18 60.2883C163.579 59.2867 165.53 59.5849 166.574 60.9525C166.719 61.1382 166.837 61.3435 166.936 61.5488C167.527 62.8361 167.23 64.4215 166.122 65.3838C166.949 65.0714 167.881 65.2571 168.499 65.8623C169.339 66.6854 169.155 67.8262 169.136 67.9191C170.799 68.8814 171.194 71.031 170.241 72.3308Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.958 69.5974C167.004 69.8027 167.102 70.3544 166.8 70.8186C166.373 71.4828 165.29 71.7202 164.246 71.2168C163.037 71.8934 161.638 71.8809 160.667 71.1632C159.984 70.6651 159.708 69.9616 159.602 69.6242C159.589 69.651 159.321 70.1223 158.782 70.142C158.343 70.1616 158.06 69.8563 158.021 69.8099C157.982 70.0563 157.856 70.7115 157.317 71.3025C156.76 71.9202 156.097 72.0988 155.859 72.1523C155.832 72.1987 155.439 72.9415 154.612 73.0147C153.988 73.0736 153.384 72.729 153.088 72.1523C152.818 72.729 152.286 73.12 151.721 73.1271C150.947 73.1396 150.191 72.4166 150.152 71.4292C150.079 71.4685 149.496 71.8077 148.851 71.5417C148.339 71.3292 147.985 70.8186 147.951 70.242V70.2348C147.938 70.0295 147.944 69.8242 147.972 69.6189C148.161 68.0263 149.299 66.6926 150.848 66.2623C150.821 66.1106 150.572 64.3716 151.872 63.1111C153.067 61.9506 154.591 62.1292 154.788 62.1559C155.071 59.9724 156.765 58.3745 158.643 58.3013C160.809 58.2156 162.116 60.1992 162.176 60.292C163.574 59.2904 165.526 59.5885 166.57 60.9562C166.714 61.1418 166.833 61.3471 166.931 61.5525C166.655 61.6525 166.346 61.7257 166.012 61.7649C165.388 61.8381 164.849 61.7524 164.475 61.6578C164.586 61.7649 164.822 62.022 164.927 62.4273C165.092 63.0968 164.731 63.6414 164.664 63.7271C164.854 63.9199 165.459 64.5823 165.558 65.6374C165.643 66.5141 165.334 67.1764 165.197 67.4282C166.038 67.1229 166.897 67.4942 167.18 68.1441C167.378 68.5958 167.28 69.16 166.958 69.5974Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85 93.1303H158.838L158.997 78.5527V78.3009L159.033 75.5389V75.2693L159.051 73.2251L159.087 71.1808V70.0685L159.14 65.6211V65.3194L159.175 62.145C159.175 62.0557 159.246 61.9664 159.353 61.9664C159.441 61.9843 159.531 62.0557 159.531 62.145L159.584 67.9368V68.1706L159.602 69.6418L159.619 71.7039L159.636 71.9557L159.653 74.0178L159.67 76.9048L159.687 77.1386L159.85 93.1303Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.35 68.3353C159.319 68.3353 159.289 68.321 159.27 68.2942C159.238 68.2495 159.248 68.1871 159.29 68.1549L164.512 64.2842C164.556 64.2521 164.617 64.261 164.649 64.3056C164.681 64.3503 164.671 64.4128 164.629 64.4449L159.407 68.3138C159.389 68.3281 159.37 68.3353 159.35 68.3353Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.35 65.8463C159.32 65.8463 159.291 65.832 159.271 65.807L156.611 62.2131C156.578 62.1684 156.587 62.1077 156.631 62.0738C156.675 62.0417 156.736 62.0488 156.768 62.0934L159.428 65.6874C159.46 65.7321 159.452 65.7946 159.408 65.8267C159.391 65.841 159.371 65.8463 159.35 65.8463Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.351 71.4305C159.325 71.4305 159.3 71.4198 159.279 71.4001L153.883 65.8154C153.846 65.7761 153.846 65.7137 153.885 65.6744C153.924 65.6369 153.987 65.6369 154.024 65.6762L159.42 71.2609C159.457 71.3001 159.457 71.3626 159.418 71.4019C159.4 71.4215 159.374 71.4305 159.351 71.4305Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.349 72.1493C159.32 72.1493 159.29 72.135 159.271 72.11C159.237 72.0653 159.248 72.0029 159.29 71.9707L165.605 67.1198C165.647 67.0877 165.71 67.0948 165.742 67.1395C165.776 67.1823 165.766 67.2466 165.723 67.2787L159.407 72.1296C159.39 72.1439 159.37 72.1493 159.349 72.1493Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.35 75.7979C159.326 75.7979 159.302 75.789 159.284 75.7711L152.301 69.2473C152.26 69.2098 152.259 69.1473 152.296 69.1063C152.333 69.067 152.396 69.0634 152.435 69.1009L159.417 75.6247C159.458 75.6622 159.46 75.7247 159.423 75.7658C159.402 75.7872 159.375 75.7979 159.35 75.7979Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.349 77.346C159.317 77.346 159.287 77.3299 159.268 77.3031C159.237 77.2567 159.249 77.196 159.295 77.1657L166.869 71.9684C166.913 71.938 166.976 71.9488 167.007 71.9952C167.037 72.0416 167.025 72.1023 166.981 72.1327L159.407 77.3299C159.387 77.3406 159.368 77.346 159.349 77.346Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.35 78.7274C159.333 78.7274 159.318 78.7238 159.303 78.7149L153.14 75.2316C153.093 75.2048 153.076 75.1441 153.103 75.0959C153.13 75.0477 153.19 75.0317 153.237 75.0584L159.399 78.5417C159.447 78.5685 159.464 78.6292 159.436 78.6774C159.418 78.7095 159.384 78.7274 159.35 78.7274Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.539 93.1309H-17.2387V109.569H406.539V93.1309Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.539 93.1309H-17.2387V96.832H406.539V93.1309Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.569 109.401H-17.2349V178.138H406.569V109.401Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.218 175.791C250.218 177.085 232.984 178.133 211.726 178.133C190.468 178.133 173.234 177.083 173.234 175.791C173.234 174.496 190.468 173.447 211.726 173.447C232.984 173.447 250.218 174.496 250.218 175.791Z",
    fill: "#29D463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.047 153.468C204.047 155.686 184.522 157.482 160.436 157.482C136.35 157.482 116.824 155.684 116.824 153.468C116.824 151.251 136.35 149.455 160.436 149.455C184.522 149.455 204.047 151.252 204.047 153.468Z",
    fill: "#29D463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8714 175.944C68.8113 175.944 88.2184 171.812 88.2184 166.714C88.2184 161.616 68.8113 157.484 44.8714 157.484C20.9315 157.484 1.52444 161.616 1.52444 166.714C1.52444 171.812 20.9315 175.944 44.8714 175.944Z",
    fill: "#29D463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.89 164.439C354.89 166.508 337.288 168.185 315.576 168.185C293.863 168.185 276.262 166.508 276.262 164.439C276.262 162.37 293.863 160.693 315.576 160.693C337.288 160.693 354.89 162.37 354.89 164.439Z",
    fill: "#29D463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.544 169.69C254.544 171.224 237.311 172.467 216.052 172.467C194.794 172.467 177.561 171.224 177.561 169.69C177.561 168.157 194.794 166.914 216.052 166.914C237.311 166.914 254.544 168.157 254.544 169.69Z",
    fill: "#29D463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.501 119.583C335.143 119.583 372.955 118.338 372.955 116.802C372.955 115.266 335.143 114.02 288.501 114.02C241.858 114.02 204.046 115.266 204.046 116.802C204.046 118.338 241.858 119.583 288.501 119.583Z",
    fill: "#29D463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.2213 123.909C-17.2213 123.909 113.75 125.797 136.739 120.68C136.739 120.68 205.988 119.987 186.565 109.569H-17.2349L-17.2213 123.909Z",
    fill: "#29D463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.523 133.668H-17.2387V144.64H406.523V133.668Z",
    fill: "#FEEBBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.837 112.578H161.493V128.782H227.837V112.578Z",
    fill: "url(#paint1_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.837 116.354H161.493V117.45H227.837V116.354Z",
    fill: "#EFEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.838 119.584H161.493V120.68H227.838V119.584Z",
    fill: "#EFEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.838 122.812H161.493V123.908H227.838V122.812Z",
    fill: "#EFEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.838 126.041H161.493V127.137H227.838V126.041Z",
    fill: "#EFEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.049 115.634H219.952V139.155H222.049V115.634Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.377 115.634H167.28V139.155H169.377V115.634Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0886192 126.043H-7.26019V145.375H0.0886192V126.043Z",
    fill: "#7F6B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.945 162.466C264.511 162.466 264.971 162.002 264.971 161.429C264.971 160.856 264.511 160.392 263.945 160.392C263.378 160.392 262.919 160.856 262.919 161.429C262.919 162.002 263.378 162.466 263.945 162.466Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.458 150.079C257.458 150.652 256.999 151.116 256.433 151.116C255.866 151.116 255.407 150.652 255.407 150.079C255.407 149.506 255.866 149.041 256.433 149.041C256.999 149.041 257.458 149.506 257.458 150.079Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.398 159.767C105.398 160.34 104.939 160.804 104.373 160.804C103.806 160.804 103.347 160.34 103.347 159.767C103.347 159.194 103.806 158.729 104.373 158.729C104.939 158.731 105.398 159.195 105.398 159.767Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2954 149.834C96.8618 149.834 97.321 149.37 97.321 148.797C97.321 148.224 96.8618 147.76 96.2954 147.76C95.729 147.76 95.2698 148.224 95.2698 148.797C95.2698 149.37 95.729 149.834 96.2954 149.834Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7099 158.11C75.2764 158.11 75.7356 157.645 75.7356 157.072C75.7356 156.499 75.2764 156.035 74.7099 156.035C74.1435 156.035 73.6843 156.499 73.6843 157.072C73.6843 157.645 74.1435 158.11 74.7099 158.11Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8598 149.833C60.8598 150.406 60.4004 150.87 59.8341 150.87C59.2679 150.87 58.8085 150.406 58.8085 149.833C58.8085 149.26 59.2679 148.796 59.8341 148.796C60.4004 148.797 60.8598 149.262 60.8598 149.833Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0158 152.509C51.0158 153.082 50.5564 153.546 49.9902 153.546C49.424 153.546 48.9646 153.082 48.9646 152.509C48.9646 151.936 49.424 151.472 49.9902 151.472C50.5564 151.472 51.0158 151.936 51.0158 152.509Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6327 161.072C48.6327 161.645 48.1733 162.109 47.6071 162.109C47.0409 162.109 46.5815 161.645 46.5815 161.072C46.5815 160.498 47.0409 160.034 47.6071 160.034C48.1733 160.034 48.6327 160.498 48.6327 161.072Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.321 157.385C97.321 157.958 96.8616 158.422 96.2954 158.422C95.7292 158.422 95.2698 157.958 95.2698 157.385C95.2698 156.812 95.7292 156.348 96.2954 156.348C96.8616 156.348 97.321 156.812 97.321 157.385Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0835 150.038C85.6499 150.038 86.1091 149.573 86.1091 149.001C86.1091 148.428 85.6499 147.963 85.0835 147.963C84.517 147.963 84.0579 148.428 84.0579 149.001C84.0579 149.573 84.517 150.038 85.0835 150.038Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8631 153.015C66.8631 153.588 66.4036 154.052 65.8374 154.052C65.2712 154.052 64.8118 153.588 64.8118 153.015C64.8118 152.441 65.2712 151.977 65.8374 151.977C66.4036 151.977 66.8631 152.441 66.8631 153.015Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6426 153.547C37.6426 154.12 37.1832 154.584 36.617 154.584C36.0508 154.584 35.5914 154.12 35.5914 153.547C35.5914 152.973 36.0508 152.509 36.617 152.509C37.1832 152.509 37.6426 152.973 37.6426 153.547Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7443 163.491C35.7443 164.064 35.2849 164.528 34.7187 164.528C34.1525 164.528 33.6931 164.064 33.6931 163.491C33.6931 162.918 34.1525 162.454 34.7187 162.454C35.2849 162.454 35.7443 162.918 35.7443 163.491Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0343 150.379C29.0343 150.952 28.5749 151.417 28.0087 151.417C27.4425 151.417 26.9831 150.952 26.9831 150.379C26.9831 149.806 27.4425 149.342 28.0087 149.342C28.5749 149.344 29.0343 149.808 29.0343 150.379Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1105 161.363C26.6769 161.363 27.1361 160.899 27.1361 160.326C27.1361 159.753 26.6769 159.288 26.1105 159.288C25.544 159.288 25.0848 159.753 25.0848 160.326C25.0848 160.899 25.544 161.363 26.1105 161.363Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.841 155.341C267.841 155.914 267.382 156.378 266.816 156.378C266.25 156.378 265.79 155.914 265.79 155.341C265.79 154.768 266.25 154.304 266.816 154.304C267.382 154.305 267.841 154.77 267.841 155.341Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.47 154.305C289.47 154.878 289.011 155.342 288.445 155.342C287.879 155.342 287.419 154.878 287.419 154.305C287.419 153.732 287.879 153.268 288.445 153.268C289.011 153.268 289.47 153.732 289.47 154.305Z",
    fill: "#F4FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.919 150.118C280.732 159.986 277.703 169.32 272.809 178.138H251.812C249.037 173.13 245.138 165.039 242.363 160.029C245.9 164.032 249.46 168.056 252.998 172.059C250.732 167.585 248.464 163.091 246.197 158.595C249.63 163.198 253.041 167.801 256.474 172.402L245.434 148.363C248.825 151.381 253.909 159.238 259.927 169.704C259.545 162.875 258.613 156.262 255.965 150.44C260.076 153.159 262.322 161.229 264.356 169.918C266.264 161.913 268.445 153.05 267.598 143.868C269.101 154.314 270.415 160.051 269.018 168.935C270.629 165.682 271.836 161.357 272.726 156.305C273.551 162.148 272.28 168.506 270.035 175.1C274.419 168.099 278.339 159.601 281.919 150.118Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.272 162.941C287.704 168.999 285.161 174.243 280.987 178.138H273.148C277.853 172.53 281.708 166.687 283.637 160.372C283.383 166.28 281.603 171.311 277.98 176.083C282.281 173.15 285.988 168.592 289.272 162.941Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.281 168.827C290.797 172.402 288.466 175.464 285.584 178.138H281.516C285.501 175.676 289.102 172.595 292.281 168.827Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.273 174.35C293.679 175.612 292.811 176.876 291.73 178.138H289.04C291.221 176.897 293.001 175.655 294.273 174.35Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.55 163.175C224.033 168.163 225.517 173.15 227 178.138H223.228C222.996 173.088 222.847 167.285 222.55 163.175Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.619 163.518C227.636 168.399 228.653 173.257 229.691 178.138H227.128C226.958 173.28 226.789 168.378 226.619 163.518Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.2 153.906C231.959 157.952 233.229 166.729 234.289 178.138H230.157L230.2 153.906Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 178.139H234.902C237.191 172.209 238.844 166.28 238.864 160.308C241.132 163.968 240.414 170.711 239.013 178.139Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.84 167.864C31.8775 171.289 32.8946 174.715 33.9118 178.139H31.3266C31.2011 174.436 31.0519 170.733 30.84 167.864Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9307 168.207C35.6088 171.524 36.3089 174.822 37.0074 178.139H35.2698C35.163 174.822 35.0358 171.502 34.9307 168.207Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5117 158.596C39.995 162.063 41.1817 169.021 42.1344 178.139H38.4693L38.5117 158.596Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1096 178.139H44.8683C46.2669 173.772 47.1569 169.384 47.1772 164.997C48.9572 167.864 48.8928 172.638 48.1096 178.139Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7045 161.506C64.9979 167.05 66.2897 172.595 67.5815 178.139H64.1283C63.9791 172.595 63.852 167.052 63.7045 161.506Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.37 155.127L72.4328 178.139H68.5981C69.8475 170.455 71.119 162.813 72.37 155.127Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9503 164.718C75.8029 169.214 75.6537 173.667 75.5062 178.139H73.1549C74.0856 173.665 75.018 169.212 75.9503 164.718Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0393 164.375C79.763 168.164 79.5935 173.388 79.4036 178.139H75.9504C77.3066 173.558 78.6628 168.978 80.0393 164.375Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.2386 161.228C-17.1013 160.79 -15.9197 157.241 -12.2495 155.877C-9.45239 154.838 -6.26875 155.461 -3.95137 157.482C-1.22375 151.81 4.78753 148.889 9.99696 150.169C16.4185 151.745 20.8413 159.508 18.2951 167.116C18.8427 167.028 21.3821 166.682 23.769 168.364C26.5966 170.356 26.9052 173.572 26.9408 174.016C28.2088 173.563 31.7179 172.5 35.9746 173.672C39.8855 174.747 42.269 177.114 43.1912 178.135C23.0468 178.135 2.90413 178.135 -17.2403 178.135V161.228H-17.2386Z",
    fill: "#3DA2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.2387 178.133C-17.1421 177.79 -16.3047 175.007 -13.6177 174.004C-12.2616 173.497 -11.0393 173.672 -10.4392 173.804C-11.836 170.831 -11.358 167.33 -9.24744 164.973C-6.35029 161.736 -2.04611 162.522 -1.83082 162.565C0.0254587 159.874 3.15993 158.455 6.18083 158.953C9.88829 159.563 12.821 162.963 12.9787 167.114C14.0162 167.226 16.4776 167.644 18.6967 169.588C22.3448 172.786 22.2906 177.448 22.2719 178.132C9.10001 178.133 -4.07021 178.133 -17.2387 178.133Z",
    fill: "url(#paint2_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4543 174.339C93.8054 172.873 97.6468 169.101 103.843 167.917C107.803 167.16 111.1 167.771 112.98 168.278C113.172 167.355 114.602 160.99 120.661 157.749C125.649 155.082 131.846 155.562 136.684 158.955C136.596 161.229 136.508 163.502 136.42 165.777L121.192 175.141L98.8114 175.944L92.4543 174.339Z",
    fill: "#3DA2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2673 178.133C73.6983 176.332 79.9452 172.225 88.7468 172.02C93.9851 171.897 98.1774 173.2 100.754 174.25C102.422 173.289 106.408 171.301 111.79 171.484C116.369 171.642 119.759 173.297 121.414 174.25C120.09 166.782 124.759 159.928 131.036 158.642C136.011 157.623 141.458 160.21 144.367 165.153C145.049 165.086 148.12 164.852 150.901 167.026C154.135 169.556 154.401 173.327 154.432 173.893C156.961 173.309 160.68 172.772 165.113 173.268C171.532 173.986 176.258 176.512 178.797 178.133C142.953 178.133 107.11 178.133 71.2673 178.133Z",
    fill: "url(#paint3_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.208 178.134C289.432 173.019 294.216 169.573 299.568 169.255C306.603 168.837 311.021 174.04 311.487 174.606C312.035 174.311 314.271 173.19 317.049 173.892C320.475 174.759 321.962 177.702 322.169 178.132C310.514 178.134 298.861 178.134 287.208 178.134Z",
    fill: "url(#paint4_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.2222 92.0133C-16.2169 91.6401 -10.1175 89.4923 -4.02312 92.8167C-0.185128 94.9092 1.70505 98.1104 2.42213 99.5065C3.57658 98.9495 5.9143 98.0193 8.95554 98.1693C12.9698 98.3675 15.728 100.326 16.7248 101.112C18.6268 96.8713 22.6428 93.9736 27.2301 93.5309C31.8208 93.0881 36.3097 95.168 38.9712 98.9709C40.0782 98.4621 43.6687 96.9838 47.9763 98.1675C50.5615 98.8781 52.333 100.253 53.2739 101.11C54.2978 100.071 60.1667 94.3093 69.4294 94.42C78.3531 94.5271 83.9677 100.003 85.056 101.11C86.363 100.597 94.256 97.6462 102.183 101.824C106.755 104.232 109.188 107.88 110.217 109.673C67.7376 109.673 25.2569 109.673 -17.2222 109.673V92.0133Z",
    fill: "url(#paint5_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.568 92.103C406.212 91.7906 397.949 84.7919 387.61 88.3341C377.267 91.8781 374.924 102.521 374.831 102.983C373.929 102.473 371.905 101.491 369.203 101.578C365.472 101.699 362.997 103.776 362.295 104.41C361.608 100.019 358.365 96.4969 354.173 95.5578C350.344 94.7008 346.309 96.1291 343.756 99.2374C343.412 99.0875 340.31 97.7931 337.223 99.5713C334.483 101.15 333.825 103.958 333.727 104.41C332.508 103.353 328.311 99.9801 322.06 99.8391C314.03 99.657 308.907 104.952 308.078 105.836C306.975 104.733 300.862 98.8429 291.27 98.9678C282.068 99.0875 276.247 104.66 275.07 105.836C274.006 105.085 271.831 103.779 268.823 103.517C263.65 103.065 259.976 106.049 259.179 106.729C258.328 105.949 255.847 103.883 252.054 103.483C249.239 103.187 247.021 103.949 245.936 104.41C243.576 101.773 240.167 100.603 237.107 101.444C234.654 102.117 233.22 103.867 232.693 104.588C232.171 104.44 229.976 103.879 227.64 105.056C224.978 106.397 224.171 108.966 224.042 109.403C284.884 109.403 345.726 109.403 406.568 109.403V92.103Z",
    fill: "url(#paint6_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.848 109.673H179.431C178.999 108.95 175.646 103.56 168.926 102.626C163.084 101.816 158.866 104.951 158.066 105.568C157.251 104.965 151.924 101.167 144.911 102.714C138.713 104.083 135.511 108.673 134.848 109.673Z",
    fill: "url(#paint7_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7875 126.53H64.5826C62.8247 119.796 57.383 115.143 51.4853 114.957C45.9063 114.781 42.0819 118.671 41.3546 119.439C40.4833 118.926 37.9015 117.568 34.7331 118.168C30.9052 118.894 27.7775 122.186 26.7875 126.53Z",
    fill: "url(#paint8_linear_491_8101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4427 17.1472C39.7614 17.7899 41.6889 21.857 39.8886 26.5651C38.0238 31.4249 33.6586 33.0943 33.0229 33.3299C32.0482 33.8227 30.4173 34.4851 28.2983 34.5922C24.8655 34.7636 22.3243 33.3514 21.3479 32.73C21.0936 32.7515 18.9118 32.7943 16.8572 31.4678C16.2215 31.0393 15.6061 30.5037 15.0552 29.777C12.9362 27.015 13.6363 23.8477 13.721 23.4193C12.6412 22.0499 12.3852 20.2734 13.0633 18.8808C13.5719 17.8524 14.4619 17.34 14.8433 17.1472C14.5246 16.6973 11.7715 13.0158 13.0006 8.30595C13.9957 4.47451 16.942 2.61235 17.5777 2.22671C18.6999 -2.16177 22.387 -5.30762 26.6455 -5.60757C30.2478 -5.84324 33.7654 -3.98108 35.7777 -0.790599C36.3286 -0.619202 40.9057 0.750197 42.6637 5.31007C44.2097 9.2897 42.9383 14.0852 39.4427 17.1472Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4435 17.1473C39.7622 17.7901 41.6897 21.8572 39.8893 26.5652C38.0246 31.4251 33.6594 33.0944 33.0237 33.3301C32.0489 33.8228 30.4181 34.4852 28.2991 34.5923C24.8662 34.7637 22.3251 33.3515 21.3486 32.7302C21.0943 32.7516 18.9126 32.7944 16.858 31.4679C17.4513 31.5108 19.6127 31.6607 21.6046 30.2056C22.854 29.2862 23.4897 28.1507 23.766 27.5293C24.5492 27.3151 28.2363 26.2671 30.3978 22.541C31.8387 20.0361 31.859 17.5955 31.7963 16.5689C35.5258 16.6117 38.8942 14.7281 40.3776 11.7519C42.3915 7.66335 40.6318 1.94833 35.7801 -0.792236C36.3311 -0.620839 40.9082 0.748552 42.6661 5.30843C44.2105 9.28984 42.9391 14.0854 39.4435 17.1473Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.327 53.5455C51.4965 54.1222 52.4984 57.7644 50.3285 61.3834C48.0857 65.1166 44.241 65.8504 43.6832 65.9504C42.8068 66.2128 41.3641 66.5181 39.6011 66.2932C36.743 65.9272 34.8511 64.3846 34.1357 63.7276C33.9238 63.7079 32.1167 63.4205 30.613 62.0207C30.1502 61.5726 29.7213 61.0406 29.3721 60.3585C28.0244 57.7662 29.0602 55.2559 29.1924 54.9149C28.4991 53.6241 28.5465 52.1208 29.3077 51.0728C29.8756 50.2997 30.6859 50.0069 31.0283 49.9051C30.8317 49.4873 29.0924 46.0415 30.7893 42.3369C32.1658 39.3213 34.8663 38.2215 35.4478 37.9966C37.0108 34.5419 40.5098 32.4905 44.0663 32.8725C47.0737 33.2118 49.7064 35.2685 50.9049 38.1983C51.3338 38.4215 54.9124 40.2283 55.7024 44.2526C56.4008 47.7662 54.6564 51.5352 51.327 53.5455Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3268 53.5463C51.4964 54.1229 52.4982 57.7651 50.3284 61.3841C48.0856 65.1174 44.2408 65.8512 43.6831 65.9511C42.8066 66.2136 41.364 66.5189 39.601 66.2939C36.7428 65.9279 34.8509 64.3854 34.1355 63.7283C33.9236 63.7087 32.1165 63.4212 30.6129 62.0215C31.096 62.1447 32.8573 62.5875 34.7119 61.6823C35.8765 61.1074 36.5665 60.2647 36.8835 59.7933C37.5616 59.7326 40.7554 59.4131 43.0796 56.6582C44.6324 54.805 45.0036 52.7946 45.0986 51.9359C48.1703 52.5233 51.2234 51.4663 52.878 49.231C55.1326 46.1548 54.5088 41.1789 50.903 38.1991C51.3319 38.4223 54.9106 40.2291 55.7005 44.2533C56.4007 47.767 54.6563 51.5359 51.3268 53.5463Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56354 50.6016C2.39402 51.1782 1.39214 54.8204 3.56203 58.4394C5.80482 62.1726 9.64959 62.9064 10.2073 63.0064C11.0838 63.2689 12.5247 63.5742 14.2894 63.3492C17.1476 62.9832 19.0395 61.4406 19.7548 60.7836C19.9667 60.764 21.7756 60.4765 23.2775 59.0768C23.7403 58.6287 24.1692 58.0966 24.5184 57.4146C25.8661 54.8222 24.8304 52.3119 24.6981 51.9709C25.3915 50.6801 25.344 49.1768 24.5829 48.1288C24.015 47.3557 23.2063 47.0647 22.8622 46.9611C23.0588 46.5434 24.7981 43.0976 23.1012 39.3929C21.723 36.3774 19.0242 35.2776 18.4427 35.0526C16.8797 31.5979 13.3808 29.5465 9.82251 29.9286C6.81517 30.2678 4.18248 32.3245 2.98396 35.2544C2.55506 35.4775 -1.02356 37.2844 -1.81354 41.3068C-2.51028 44.824 -0.765888 48.593 2.56354 50.6016Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5634 50.6018C2.39388 51.1785 1.392 54.8207 3.56189 58.4397C5.80468 62.1729 9.64945 62.9067 10.2072 63.0067C11.0836 63.2691 12.5246 63.5744 14.2893 63.3495C17.1474 62.9835 19.0393 61.4409 19.7547 60.7839C19.9666 60.7642 21.7754 60.4768 23.2774 59.0771C22.7943 59.2002 21.0329 59.643 19.1783 58.7378C18.0137 58.1629 17.3238 57.3202 17.0067 56.8489C16.3287 56.7882 13.1348 56.4686 10.8107 53.7137C9.25786 51.8605 8.8866 49.8502 8.78997 48.9914C5.71822 49.5788 2.66512 48.5218 1.01057 46.2865C-1.24408 43.2103 -0.620237 38.2327 2.98551 35.2546C2.55662 35.4778 -1.02201 37.2846 -1.81198 41.3071C-2.51042 44.8243 -0.766027 48.5933 2.5634 50.6018Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9799 126.167H25.2048L25.8202 66.4668V65.6955L26.0948 38.3595L26.1152 37.1401L26.222 20.627C26.222 20.4128 26.3915 20.2628 26.6034 20.2628C26.795 20.2628 26.9645 20.4342 26.9645 20.627L27.0492 34.1853V35.0637L27.4086 71.0892L27.4307 71.8819L27.9799 126.167Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5959 72.4011C26.4925 72.4011 26.3908 72.3511 26.3314 72.2565C26.2348 72.1083 26.2755 71.9101 26.4213 71.8119C34.9144 66.1451 39.0863 49.9999 39.127 49.8392C39.1711 49.6696 39.3355 49.5696 39.5135 49.6071C39.683 49.6517 39.7864 49.8267 39.7441 49.9981C39.5728 50.6712 35.4687 66.5451 26.7722 72.3476C26.7179 72.3851 26.6552 72.4011 26.5959 72.4011Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5962 66.8092C26.5521 66.8092 26.5097 66.8003 26.4673 66.7824C20.4255 64.0704 14.8042 52.3672 14.5668 51.8709C14.4905 51.7102 14.5567 51.5192 14.7143 51.4424C14.8805 51.3656 15.0635 51.4335 15.1381 51.5924C15.1958 51.712 20.8951 63.5795 26.7233 66.1933C26.8844 66.2647 26.9573 66.4557 26.8844 66.6182C26.8335 66.7378 26.7182 66.8092 26.5962 66.8092Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5962 35.3899C26.5131 35.3899 26.43 35.3578 26.369 35.2935C26.247 35.1668 26.2487 34.9632 26.3758 34.8383L34.6299 26.6773C34.7519 26.5559 34.957 26.5576 35.0791 26.6826C35.2012 26.8094 35.1995 27.0129 35.0723 27.1379L26.8183 35.2989C26.7572 35.3596 26.6759 35.3899 26.5962 35.3899Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5961 38.8681C26.4893 38.8681 26.3825 38.8146 26.3249 38.7128L19.349 27.0739C19.2575 26.9221 19.305 26.7239 19.4541 26.6329C19.6033 26.54 19.8017 26.5883 19.8915 26.7418L26.8674 38.3807C26.9589 38.5325 26.9114 38.7289 26.7623 38.8217C26.7097 38.8539 26.6521 38.8681 26.5961 38.8681Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.828 32.2995C118.093 32.8345 119.697 36.2197 118.199 40.1384C116.647 44.1834 113.013 45.5729 112.484 45.7691C111.673 46.1792 110.316 46.7305 108.552 46.8197C105.694 46.9624 103.579 45.7869 102.767 45.2697C102.555 45.2876 100.739 45.3232 99.0289 44.2191C98.4997 43.8625 97.9875 43.4166 97.529 42.8118C95.7652 40.5129 96.348 37.8766 96.4185 37.52C95.5197 36.3802 95.3066 34.9016 95.871 33.7425C96.2943 32.8865 97.0351 32.46 97.3526 32.2995C97.0873 31.925 94.7958 28.8608 95.8188 24.9406C96.6471 21.7515 99.0994 20.2016 99.6285 19.8806C100.563 16.2279 103.632 13.6094 107.176 13.3598C110.174 13.1636 113.102 14.7136 114.777 17.3691C115.236 17.5118 119.045 18.6516 120.509 22.447C121.795 25.7594 120.737 29.7509 117.828 32.2995Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.828 32.2996C118.093 32.8346 119.698 36.2198 118.199 40.1385C116.647 44.1836 113.014 45.573 112.485 45.7692C111.673 46.1793 110.316 46.7307 108.552 46.8198C105.695 46.9625 103.58 45.787 102.767 45.2699C102.555 45.2877 100.739 45.3234 99.0293 44.2192C99.5231 44.2549 101.322 44.3797 102.98 43.1686C104.02 42.4033 104.549 41.4582 104.779 40.941C105.431 40.7627 108.5 39.8904 110.299 36.789C111.498 34.7041 111.515 32.6726 111.463 31.8181C114.567 31.8538 117.371 30.286 118.606 27.8088C120.282 24.4057 118.817 19.6489 114.779 17.3678C115.238 17.5105 119.047 18.6503 120.51 22.4456C121.796 25.7595 120.738 29.7511 117.828 32.2996Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.72 62.5954C127.861 63.0754 128.695 66.107 126.888 69.1192C125.022 72.2265 121.821 72.8373 121.357 72.9205C120.628 73.139 119.427 73.3931 117.96 73.2058C115.581 72.9012 114.006 71.6172 113.41 71.0704C113.234 71.054 111.73 70.8148 110.478 69.6497C110.093 69.2767 109.736 68.8339 109.446 68.2662C108.324 66.1085 109.186 64.0191 109.296 63.7352C108.719 62.6608 108.758 61.4096 109.392 60.5373C109.865 59.8938 110.539 59.6501 110.824 59.5654C110.66 59.2176 109.213 56.3496 110.625 53.266C111.771 50.7561 114.019 49.8407 114.503 49.6534C115.804 46.7779 118.716 45.0704 121.676 45.3885C124.179 45.6708 126.371 47.3827 127.368 49.8213C127.725 50.0071 130.704 51.511 131.361 54.8605C131.943 57.7851 130.491 60.9221 127.72 62.5954Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.72 62.5959C127.861 63.0758 128.695 66.1074 126.888 69.1196C125.022 72.227 121.822 72.8377 121.357 72.9209C120.628 73.1394 119.427 73.3935 117.96 73.2063C115.581 72.9016 114.006 71.6177 113.411 71.0708C113.234 71.0545 111.73 70.8152 110.478 69.6501C110.881 69.7527 112.347 70.1212 113.89 69.3678C114.86 68.8893 115.434 68.1879 115.698 67.7955C116.262 67.745 118.921 67.479 120.855 65.186C122.147 63.6435 122.456 61.9702 122.536 61.2554C125.092 61.7444 127.633 60.8646 129.011 59.0041C130.887 56.4436 130.368 52.302 127.367 49.8218C127.724 50.0075 130.702 51.5114 131.36 54.861C131.943 57.7855 130.491 60.9226 127.72 62.5959Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1315 60.145C86.9904 60.625 86.1565 63.6565 87.9626 66.6688C89.8294 69.7761 93.0295 70.3869 93.4937 70.4701C94.2232 70.6885 95.4226 70.9426 96.8915 70.7554C99.2704 70.4508 100.845 69.1668 101.441 68.6199C101.617 68.6036 103.122 68.3643 104.373 67.1993C104.758 66.8263 105.115 66.3834 105.405 65.8158C106.527 63.658 105.665 61.5686 105.555 61.2848C106.132 60.2104 106.093 58.9591 105.459 58.0868C104.986 57.4434 104.313 57.2011 104.027 57.1149C104.191 56.7672 105.638 53.8991 104.226 50.8156C103.079 48.3056 100.832 47.3902 100.348 47.203C99.0475 44.3275 96.1352 42.62 93.1734 42.938C90.6703 43.2204 88.479 44.9323 87.4814 47.3709C87.1245 47.5567 84.1458 49.0605 83.4883 52.4086C82.9084 55.3361 84.3603 58.4732 87.1315 60.145Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1312 60.1453C86.9901 60.6253 86.1562 63.6568 87.9623 66.6691C89.8291 69.7764 93.0293 70.3872 93.4935 70.4704C94.223 70.6888 95.4223 70.9429 96.8912 70.7557C99.2701 70.4511 100.845 69.1671 101.44 68.6202C101.617 68.6039 103.122 68.3646 104.372 67.1996C103.97 67.3021 102.504 67.6707 100.961 66.9172C99.9912 66.4387 99.4169 65.7373 99.153 65.345C98.5886 65.2945 95.9303 65.0285 93.9958 62.7355C92.7033 61.193 92.3943 59.5197 92.3139 58.8049C89.7571 59.2938 87.2159 58.4141 85.8388 56.5535C83.9621 53.9931 84.4814 49.8499 87.4826 47.3712C87.1256 47.557 84.147 49.0609 83.4894 52.4089C82.9081 55.3364 84.36 58.4735 87.1312 60.1453Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.287 123.041H105.977L106.489 73.3502V72.7082L106.718 49.9553L106.734 48.9403L106.823 35.1959C106.823 35.0175 106.964 34.8927 107.141 34.8927C107.3 34.8927 107.441 35.0354 107.441 35.1959L107.512 46.4809V47.2121L107.811 77.1976L107.829 77.8574L108.287 123.041Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.134 78.2896C107.048 78.2896 106.964 78.248 106.914 78.1692C106.834 78.0459 106.868 77.8809 106.989 77.7992C114.058 73.0825 117.531 59.6441 117.564 59.5104C117.601 59.3692 117.738 59.286 117.886 59.3172C118.027 59.3544 118.113 59.5 118.078 59.6426C117.936 60.2029 114.52 73.4154 107.281 78.245C107.236 78.2762 107.184 78.2896 107.134 78.2896Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.135 73.6352C107.098 73.6352 107.063 73.6278 107.027 73.613C101.999 71.3556 97.3196 61.6146 97.1221 61.2015C97.0586 61.0677 97.1136 60.9087 97.2449 60.8448C97.3831 60.7809 97.5355 60.8374 97.5976 60.9697C97.6456 61.0692 102.389 70.947 107.24 73.1226C107.374 73.182 107.435 73.341 107.374 73.4762C107.332 73.5758 107.236 73.6352 107.135 73.6352Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.135 47.4838C107.065 47.4838 106.996 47.4571 106.945 47.4036C106.844 47.2981 106.845 47.1287 106.951 47.0247L113.821 40.2319C113.923 40.1309 114.094 40.1324 114.195 40.2364C114.297 40.3419 114.295 40.5113 114.19 40.6153L107.319 47.4081C107.269 47.4586 107.201 47.4838 107.135 47.4838Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.135 50.3789C107.046 50.3789 106.957 50.3344 106.909 50.2497L101.103 40.5621C101.026 40.4358 101.066 40.2708 101.19 40.195C101.314 40.1178 101.479 40.1579 101.554 40.2857L107.36 49.9733C107.437 50.0996 107.397 50.263 107.273 50.3403C107.229 50.3671 107.181 50.3789 107.135 50.3789Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.622 47.5072C305.059 51.0387 299.719 52.2599 295.226 49.8621C295.079 50.2049 293.319 53.865 289.337 54.5506C286.667 55.0005 284.59 53.8436 283.977 53.4793C280.778 55.8343 276.836 55.9414 274.443 53.9935C272.79 52.667 272.324 50.7173 272.176 49.8836C271.732 50.3121 270.8 51.103 269.359 51.5315C267.77 51.9814 266.434 51.7457 265.841 51.5958C263.68 56.8823 258.467 60.1156 253.129 59.6229C248.594 59.1944 244.61 56.1342 242.81 51.7243C238.594 49.6051 235.902 45.3665 235.712 40.7638V40.7424C235.669 40.0782 235.691 39.4159 235.776 38.7517C236.39 33.6133 240.057 29.3123 245.056 27.9197C244.971 27.427 244.166 21.8191 248.362 17.752C252.218 14.0062 257.133 14.5847 257.768 14.6686C258.679 7.62705 264.146 2.46728 270.206 2.23161C277.197 1.95309 281.415 8.3537 281.605 8.65364C286.118 5.42209 292.41 6.38441 295.781 10.7943C296.247 11.3942 296.628 12.0566 296.945 12.7208C298.852 16.8736 297.9 21.9887 294.318 25.0935C296.988 24.0865 299.997 24.6864 301.988 26.6343C304.701 29.2891 304.107 32.9706 304.043 33.2706C309.424 36.3771 310.695 43.3116 307.622 47.5072Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.028 38.6892C297.177 39.3534 297.494 41.1299 296.519 42.6278C295.143 44.7685 291.646 45.5398 288.277 43.9115C284.378 46.095 279.865 46.0522 276.729 43.7401C274.525 42.135 273.635 39.8658 273.296 38.7732C273.254 38.8589 272.386 40.3782 270.648 40.4425C269.23 40.5068 268.317 39.5212 268.19 39.373C268.063 40.1658 267.661 42.285 265.924 44.19C264.122 46.1807 261.982 46.7592 261.22 46.9306C261.135 47.0806 259.863 49.4783 257.193 49.714C255.181 49.9068 253.232 48.7928 252.277 46.9306C251.409 48.7928 249.692 50.055 247.87 50.0764C245.369 50.1193 242.933 47.7858 242.806 44.5971C242.574 44.7256 240.687 45.8165 238.61 44.9613C236.957 44.2757 235.813 42.6278 235.708 40.7656V40.7442C235.666 40.0801 235.688 39.4177 235.773 38.7535C236.386 33.6152 240.053 29.3142 245.052 27.9216C244.967 27.4288 244.162 21.8209 248.358 17.7538C252.215 14.0081 257.129 14.5865 257.765 14.6704C258.675 7.62888 264.142 2.46911 270.203 2.23344C277.194 1.95492 281.411 8.35553 281.601 8.65547C286.114 5.42393 292.407 6.38624 295.777 10.7961C296.243 11.396 296.624 12.0584 296.941 12.7226C296.051 13.044 295.056 13.2796 293.975 13.4082C291.963 13.6438 290.225 13.3653 289.016 13.0654C289.377 13.4082 290.14 14.2419 290.479 15.5489C291.008 17.711 289.843 19.466 289.632 19.7445C290.247 20.3658 292.195 22.5065 292.513 25.9095C292.788 28.7357 291.793 30.8764 291.347 31.6887C294.06 30.705 296.835 31.903 297.747 34.0008C298.384 35.4559 298.065 37.2752 297.028 38.6892Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.125 116.219H270.841L271.349 67.5424V66.8139L271.456 57.8656V57.0086L271.519 50.4366L271.604 43.8217V42.9219L271.624 40.2242L271.794 25.8822V24.8127L271.899 14.6664C271.899 14.345 272.153 14.0879 272.492 14.0879C272.789 14.0879 273.043 14.345 273.063 14.6664L273.255 33.3111L273.275 34.1039L273.318 38.8351L273.382 45.4928L273.402 46.307L273.465 52.9647L273.55 62.2541L273.57 63.0039L274.125 116.219Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.478 34.6125C272.382 34.6125 272.283 34.5678 272.222 34.4821C272.119 34.3393 272.149 34.1376 272.29 34.0322L289.135 21.547C289.278 21.4417 289.476 21.472 289.58 21.6167C289.683 21.7595 289.652 21.9612 289.512 22.0666L272.666 34.5518C272.609 34.5928 272.544 34.6125 272.478 34.6125Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.479 26.5861C272.382 26.5861 272.287 26.5414 272.225 26.4575L263.643 14.8632C263.538 14.7204 263.567 14.5204 263.708 14.4133C263.848 14.3079 264.047 14.3347 264.152 14.4776L272.733 26.0719C272.838 26.2147 272.809 26.4147 272.669 26.5218C272.611 26.5664 272.545 26.5861 272.479 26.5861Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.479 44.6036C272.396 44.6036 272.312 44.5715 272.251 44.5072L254.843 26.4909C254.721 26.3623 254.723 26.1606 254.85 26.0356C254.975 25.9124 255.177 25.916 255.299 26.041L272.707 44.0573C272.83 44.1841 272.828 44.3876 272.701 44.5126C272.638 44.5733 272.558 44.6036 272.479 44.6036Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.478 46.9212C272.383 46.9212 272.289 46.8766 272.226 46.7944C272.117 46.6534 272.148 46.4517 272.285 46.3445L292.662 30.6903C292.801 30.5849 292.999 30.6117 293.106 30.7528C293.214 30.8938 293.184 31.0955 293.047 31.2027L272.67 46.8569C272.612 46.9016 272.546 46.9212 272.478 46.9212Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.478 58.696C272.402 58.696 272.322 58.6674 272.263 58.612L249.735 37.5641C249.605 37.4427 249.598 37.2392 249.716 37.1089C249.839 36.9803 250.039 36.9714 250.166 37.091L272.695 58.1389C272.826 58.2603 272.833 58.4639 272.714 58.5942C272.648 58.6602 272.563 58.696 272.478 58.696Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.478 63.6893C272.376 63.6893 272.278 63.6393 272.215 63.55C272.115 63.4018 272.156 63.2037 272.3 63.1037L296.739 46.3353C296.881 46.2389 297.079 46.2728 297.179 46.421C297.279 46.5674 297.239 46.7674 297.095 46.8674L272.656 63.6357C272.602 63.6714 272.539 63.6893 272.478 63.6893Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.478 68.1492C272.423 68.1492 272.373 68.1367 272.322 68.1081L252.442 56.8709C252.289 56.7834 252.235 56.5888 252.32 56.4335C252.406 56.2782 252.599 56.2228 252.752 56.3103L272.632 67.5475C272.785 67.635 272.839 67.8296 272.754 67.985C272.696 68.0921 272.59 68.1492 272.478 68.1492Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.718 76.554C320.187 78.6625 317 79.3909 314.319 77.9591C314.23 78.1644 313.179 80.3497 310.803 80.7585C309.209 81.0263 307.968 80.3372 307.602 80.1194C305.692 81.5245 303.339 81.5888 301.909 80.4265C300.923 79.6338 300.645 78.4715 300.557 77.9733C300.29 78.2287 299.734 78.7018 298.875 78.9571C297.926 79.2249 297.129 79.0856 296.775 78.9946C295.485 82.1511 292.372 84.0811 289.185 83.7866C286.478 83.5312 284.099 81.703 283.025 79.0714C280.507 77.8055 278.902 75.2756 278.787 72.5279V72.5154C278.761 72.119 278.775 71.7227 278.824 71.3264C279.19 68.2591 281.379 65.6899 284.364 64.8597C284.313 64.5651 283.833 61.2175 286.337 58.7894C288.639 56.5523 291.574 56.8986 291.953 56.9486C292.498 52.744 295.761 49.6642 299.378 49.5232C303.552 49.3572 306.07 53.1779 306.183 53.3564C308.877 51.4264 312.633 52.0013 314.646 54.6348C314.924 54.9918 315.153 55.3882 315.341 55.7846C316.48 58.2645 315.91 61.3175 313.773 63.1707C315.366 62.5708 317.163 62.9279 318.351 64.0902C319.97 65.6756 319.616 67.8734 319.579 68.0519C322.795 69.9087 323.552 74.0491 321.718 76.554Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.396 71.289C315.484 71.6853 315.674 72.7459 315.092 73.6403C314.27 74.9187 312.183 75.3775 310.173 74.4063C307.845 75.7096 305.151 75.6846 303.278 74.3045C301.963 73.3457 301.432 71.9906 301.229 71.3407C301.203 71.3925 300.684 72.2995 299.647 72.337C298.799 72.3745 298.255 71.7871 298.179 71.6978C298.103 72.171 297.864 73.435 296.826 74.5723C295.751 75.7614 294.473 76.1059 294.017 76.2077C293.966 76.297 293.207 77.7289 291.613 77.8681C290.411 77.9824 289.248 77.3182 288.679 76.2077C288.16 77.32 287.136 78.0734 286.048 78.0859C284.556 78.1109 283.1 76.7183 283.025 74.8151C282.886 74.8919 281.761 75.5435 280.521 75.0329C279.535 74.6241 278.852 73.6403 278.789 72.528V72.5155C278.763 72.1192 278.777 71.7228 278.826 71.3265C279.192 68.2592 281.381 65.69 284.366 64.8598C284.315 64.5652 283.836 61.2176 286.339 58.7895C288.642 56.5524 291.576 56.8988 291.956 56.9488C292.5 52.7442 295.763 49.6644 299.381 49.5233C303.554 49.3573 306.072 53.178 306.185 53.3566C308.879 51.4266 312.636 52.0014 314.648 54.6349C314.926 54.992 315.155 55.3883 315.343 55.7847C314.812 55.9757 314.217 56.1168 313.572 56.1935C312.37 56.3346 311.332 56.1685 310.612 55.99C310.827 56.1935 311.283 56.6934 311.485 57.4719C311.802 58.7627 311.105 59.8107 310.978 59.9768C311.346 60.3481 312.509 61.6247 312.699 63.6564C312.863 65.3436 312.268 66.622 312.003 67.1076C313.622 66.5202 315.279 67.2361 315.823 68.4877C316.204 69.359 316.014 70.4463 315.396 71.289Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.708 117.089H299.759L300.056 88.5339L300.078 88.084L300.12 82.7332L300.14 82.219L300.161 78.3233L300.203 74.3633L300.225 73.8062V72.2226L300.33 63.6384V63.0171L300.395 56.9593C300.395 56.7665 300.542 56.5951 300.734 56.5951C300.924 56.5951 301.073 56.7665 301.093 56.9593L301.2 68.0912L301.22 68.5625L301.242 71.4102L301.285 75.3702V75.8416L301.327 79.8015L301.39 85.3452V85.8165L301.708 117.089Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.739 68.8566C300.681 68.8566 300.623 68.8298 300.586 68.7781C300.525 68.6924 300.544 68.5727 300.627 68.5103L310.683 61.0563C310.768 60.9938 310.886 61.0116 310.949 61.0973C311.01 61.183 310.991 61.3027 310.908 61.3651L300.852 68.8191C300.817 68.8441 300.778 68.8566 300.739 68.8566Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.739 64.0632C300.681 64.0632 300.624 64.0364 300.586 63.9864L295.464 57.0645C295.401 56.9788 295.418 56.8591 295.502 56.7967C295.587 56.7342 295.706 56.7502 295.769 56.8359L300.892 63.7579C300.954 63.8436 300.937 63.9632 300.853 64.0257C300.817 64.0525 300.778 64.0632 300.739 64.0632Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.739 74.8203C300.69 74.8203 300.641 74.8007 300.604 74.7632L290.212 64.0062C290.139 63.9294 290.141 63.8098 290.215 63.7348C290.29 63.6616 290.41 63.6634 290.483 63.7384L300.875 74.4954C300.948 74.5721 300.946 74.6917 300.872 74.7667C300.834 74.8024 300.787 74.8203 300.739 74.8203Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.739 76.204C300.681 76.204 300.625 76.1772 300.588 76.129C300.523 76.0451 300.54 75.9237 300.623 75.8594L312.788 66.5147C312.871 66.4522 312.99 66.4683 313.054 66.5522C313.119 66.6361 313.102 66.7575 313.019 66.8218L300.854 76.1665C300.818 76.1915 300.779 76.204 300.739 76.204Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.739 83.2327C300.693 83.2327 300.646 83.2166 300.61 83.1827L287.16 70.6171C287.082 70.5439 287.079 70.4243 287.148 70.3458C287.221 70.269 287.342 70.2636 287.416 70.335L300.866 82.9006C300.944 82.972 300.948 83.0934 300.878 83.172C300.841 83.2112 300.79 83.2327 300.739 83.2327Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.739 86.2143C300.678 86.2143 300.618 86.1839 300.581 86.1303C300.522 86.0429 300.546 85.9232 300.632 85.8643L315.221 75.8537C315.306 75.7965 315.425 75.8162 315.484 75.9036C315.543 75.9911 315.52 76.1108 315.433 76.1697L300.844 86.1803C300.812 86.2035 300.776 86.2143 300.739 86.2143Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.739 88.8764C300.707 88.8764 300.676 88.8692 300.646 88.8514L288.777 82.1419C288.686 82.0901 288.654 81.9741 288.705 81.8812C288.757 81.7884 288.871 81.7562 288.962 81.808L300.831 88.5175C300.922 88.5693 300.954 88.6853 300.903 88.7782C300.87 88.8424 300.805 88.8764 300.739 88.8764Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.119 80.0795C237.092 81.493 234.956 81.9813 233.158 81.0215C233.099 81.1591 232.395 82.6241 230.801 82.8981C229.733 83.0777 228.901 82.6157 228.656 82.4697C227.375 83.4116 225.798 83.4547 224.84 82.6755C224.178 82.1441 223.992 81.365 223.933 81.031C223.754 81.2022 223.382 81.5194 222.805 81.6905C222.169 81.87 221.635 81.7767 221.397 81.7156C220.532 83.8317 218.446 85.1255 216.31 84.928C214.495 84.7569 212.9 83.5313 212.18 81.7671C210.492 80.9185 209.416 79.2226 209.339 77.3806V77.3722C209.322 77.1065 209.331 76.8408 209.364 76.5751C209.609 74.5189 211.076 72.7966 213.078 72.2401C213.043 72.0426 212.722 69.7984 214.4 68.1707C215.944 66.671 217.911 66.9032 218.165 66.9367C218.53 64.1181 220.718 62.0535 223.143 61.959C225.941 61.8477 227.628 64.409 227.704 64.5286C229.51 63.2348 232.029 63.6202 233.378 65.3856C233.564 65.625 233.717 65.8907 233.843 66.1564C234.607 67.8188 234.225 69.8655 232.792 71.1078C233.86 70.7057 235.065 70.945 235.862 71.7242C236.947 72.787 236.71 74.2604 236.685 74.38C238.84 75.6248 239.348 78.4003 238.119 80.0795Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.88 76.55C233.939 76.8157 234.067 77.5266 233.677 78.1262C233.126 78.9832 231.727 79.2908 230.379 78.6397C228.819 79.5134 227.013 79.4967 225.757 78.5715C224.875 77.9288 224.519 77.0203 224.383 76.5847C224.366 76.6194 224.018 77.2274 223.323 77.2525C222.755 77.2777 222.39 76.8839 222.339 76.8241C222.288 77.1412 222.127 77.9886 221.432 78.751C220.711 79.5481 219.854 79.7791 219.549 79.8473C219.515 79.9072 219.006 80.8671 217.937 80.9604C217.132 81.037 216.352 80.5918 215.97 79.8473C215.622 80.593 214.936 81.0981 214.206 81.1064C213.206 81.1232 212.23 80.1896 212.18 78.9138C212.087 78.9652 211.332 79.4021 210.502 79.0598C209.84 78.7857 209.382 78.1262 209.34 77.3806V77.3722C209.323 77.1065 209.332 76.8408 209.365 76.5751C209.611 74.5189 211.078 72.7966 213.079 72.2401C213.045 72.0426 212.723 69.7984 214.402 68.1707C215.945 66.671 217.912 66.9032 218.167 66.9367C218.532 64.1181 220.719 62.0535 223.144 61.959C225.942 61.8477 227.63 64.409 227.706 64.5286C229.512 63.2348 232.03 63.6202 233.379 65.3856C233.565 65.625 233.719 65.8907 233.845 66.1564C233.489 66.2844 233.09 66.379 232.657 66.4305C231.852 66.525 231.156 66.4137 230.673 66.294C230.818 66.4305 231.123 66.7656 231.258 67.2874C231.471 68.1528 231.004 68.8553 230.919 68.9666C231.165 69.2156 231.945 70.0713 232.072 71.4334C232.182 72.5644 231.783 73.4214 231.606 73.7469C232.692 73.3531 233.802 73.8331 234.167 74.6721C234.422 75.2562 234.295 75.985 233.88 76.55Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.705 107.253H223.398L223.597 88.1107L223.612 87.8091L223.64 84.2221L223.654 83.8774L223.667 81.2658L223.696 78.6112L223.711 78.2377V77.1761L223.781 71.4216V71.0051L223.824 66.9441C223.824 66.8149 223.923 66.7 224.051 66.7C224.179 66.7 224.279 66.8149 224.292 66.9441L224.364 74.4066L224.378 74.7225L224.392 76.6316L224.421 79.2862V79.6022L224.449 82.2568L224.491 85.9731V86.2891L224.705 107.253Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.055 74.9197C224.016 74.9197 223.977 74.9018 223.952 74.8671C223.911 74.8096 223.924 74.7294 223.98 74.6875L230.721 69.6906C230.778 69.6487 230.857 69.6607 230.899 69.7181C230.94 69.7756 230.928 69.8558 230.872 69.8977L224.131 74.8946C224.107 74.9113 224.081 74.9197 224.055 74.9197Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.055 71.7063C224.016 71.7063 223.978 71.6884 223.953 71.6549L220.519 67.0146C220.477 66.9571 220.488 66.877 220.545 66.8351C220.602 66.7932 220.681 66.804 220.723 66.8614L224.157 71.5017C224.199 71.5591 224.188 71.6393 224.131 71.6812C224.107 71.6991 224.081 71.7063 224.055 71.7063Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.055 78.9176C224.022 78.9176 223.989 78.9044 223.964 78.8793L216.998 71.6682C216.949 71.6167 216.95 71.5365 217 71.4863C217.05 71.4372 217.131 71.4384 217.18 71.4887L224.146 78.6998C224.195 78.7512 224.194 78.8314 224.144 78.8817C224.119 78.9056 224.087 78.9176 224.055 78.9176Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.055 79.8451C224.016 79.8451 223.979 79.8271 223.954 79.7948C223.911 79.7386 223.922 79.6572 223.978 79.6141L232.133 73.3497C232.188 73.3078 232.268 73.3186 232.311 73.3748C232.354 73.4311 232.343 73.5125 232.287 73.5555L224.132 79.8199C224.108 79.8367 224.082 79.8451 224.055 79.8451Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.055 84.5569C224.024 84.5569 223.993 84.5461 223.969 84.5234L214.952 76.0998C214.9 76.0508 214.898 75.9706 214.944 75.9179C214.993 75.8664 215.074 75.8629 215.124 75.9107L224.14 84.3343C224.193 84.3821 224.195 84.4635 224.148 84.5162C224.123 84.5425 224.089 84.5569 224.055 84.5569Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.055 86.5557C224.014 86.5557 223.974 86.5354 223.949 86.4995C223.91 86.4408 223.926 86.3606 223.983 86.3211L233.764 79.6103C233.82 79.572 233.9 79.5852 233.94 79.6438C233.98 79.7025 233.964 79.7827 233.906 79.8222L224.126 86.533C224.104 86.5486 224.08 86.5557 224.055 86.5557Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.055 88.3404C224.033 88.3404 224.013 88.3356 223.992 88.3236L216.036 83.8258C215.975 83.7911 215.953 83.7133 215.988 83.6511C216.023 83.5888 216.099 83.5673 216.16 83.602L224.116 88.0998C224.178 88.1345 224.199 88.2123 224.165 88.2746C224.143 88.3177 224.099 88.3404 224.055 88.3404Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0419 79.5532C86.3508 85.0754 83.3639 91.0046 78.9359 92.2687C75.2912 93.2739 70.8633 91.0921 68.9765 86.7465C68.4052 87.1964 67.0914 88.0731 65.2046 88.2873C63.2127 88.523 61.687 87.9016 61.0309 87.6017C56.8776 94.1309 49.3135 95.6931 44.95 92.5686C43.8261 91.7759 42.9157 90.6636 42.3021 89.38C41.2205 87.3464 40.7763 84.8201 40.9883 82.2741C40.8408 82.1241 39.0608 80.3263 39.5049 77.7357C39.8016 75.8521 41.1357 74.3113 42.9157 73.7328C41.5172 70.1156 42.0054 66.1342 44.2499 63.4365C46.1994 61.0601 48.827 60.4817 49.717 60.3317C48.9541 57.9982 49.4407 55.4505 51.0087 53.674C52.7463 51.6619 55.5435 50.9763 58.0643 51.919C58.2542 51.4905 59.5476 48.7945 62.3651 48.0233C65.2249 47.252 68.5103 48.7945 70.2258 51.919C70.8836 51.7476 73.6163 51.062 75.7777 52.626C78.4901 54.5738 79.3801 59.2837 77.0915 63.5651C78.3629 63.2437 79.6767 63.6507 80.4599 64.6345C81.3499 65.7254 81.2007 67.0537 81.1804 67.2679C84.0623 68.3606 86.0542 70.9922 86.2237 73.9256C86.3949 77.0501 84.403 79.1907 84.0419 79.5532Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0933 63.5636C76.5204 63.9279 75.3337 64.592 73.7029 64.6331C71.1601 64.7402 69.4224 63.328 68.9783 62.9423C69.1478 63.328 70.0378 65.2116 69.275 67.3094C68.5324 69.3644 66.5202 70.7766 64.1893 70.9266C67.495 74.7366 66.5423 80.2588 63.2789 82.3352C60.631 84.0474 56.5201 83.4475 53.9145 80.473C53.428 81.7139 52.3685 83.876 50.207 85.8238C47.1132 88.6287 43.6601 89.2054 42.3039 89.3768C41.2223 87.3432 40.7782 84.8169 40.9901 82.2709C40.8426 82.121 39.0626 80.3231 39.5068 77.7325C39.8034 75.8489 41.1376 74.3081 42.9176 73.7296C41.519 70.1124 42.0072 66.131 44.2517 63.4333C46.2012 61.057 48.8288 60.4785 49.7188 60.3285C48.956 57.995 49.4425 55.4473 51.0106 53.6708C52.7482 51.6587 55.5453 50.9731 58.0661 51.9158C58.256 51.4873 59.5494 48.7914 62.3669 48.0201C65.2268 47.2488 68.5121 48.7914 70.2277 51.9158C70.8854 51.7444 73.6181 51.0588 75.7795 52.6228C78.4919 54.5742 79.3819 59.2823 77.0933 63.5636Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5666 109.837H63.5645L63.7985 100.51V99.8658L63.9205 89.3124L63.9578 86.2576V85.747L64.0799 74.8901V74.4634L64.2511 59.6625C64.2629 59.4929 64.3986 59.359 64.5698 59.359C64.741 59.359 64.8766 59.4929 64.8766 59.6625L65.0004 71.1158L65.0122 71.5532L65.1479 83.5171V84.1009L65.2089 89.3231L65.2818 95.3363V96.0308L65.5666 109.837Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5672 86.8122C64.5198 86.8122 64.4706 86.7944 64.4333 86.7569L57.9355 80.0617C57.8643 79.9885 57.8677 79.8742 57.9423 79.8046C58.0135 79.7332 58.1321 79.735 58.2033 79.8099L64.7012 86.5051C64.7724 86.5783 64.769 86.6926 64.6944 86.7622C64.6605 86.7961 64.613 86.8122 64.5672 86.8122Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8952 83.0299C60.8952 83.0299 60.8935 83.0299 60.8901 83.0299C55.8655 82.9102 51.0002 75.3848 50.968 75.3402C50.9086 75.2581 50.9256 75.1438 51.0087 75.0849C51.09 75.0278 51.2053 75.0438 51.2663 75.126C51.2985 75.1688 56.0604 82.5496 60.9003 82.6657C61.002 82.6674 61.0834 82.7514 61.08 82.8513C61.0766 82.9513 60.9935 83.0299 60.8952 83.0299Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8563 83.7543C64.8309 83.7418 64.8088 83.7239 64.7902 83.6989C64.7275 83.6168 64.7427 83.5025 64.8224 83.4418C68.2179 80.8816 67.7026 75.0987 67.6958 75.0398C67.6873 74.938 67.7602 74.8506 67.8602 74.8434C67.9603 74.8381 68.0501 74.913 68.0603 75.0148C68.084 75.2612 68.6027 81.0583 65.0462 83.7382C64.9902 83.7811 64.9173 83.7846 64.8563 83.7543Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3841 75.0506C64.3518 75.0506 64.3196 75.0417 64.2891 75.0256C55.5926 69.8855 55.8503 60.7264 55.8554 60.6336C55.8588 60.5354 55.9401 60.4586 56.0385 60.4586H56.0452C56.1469 60.4622 56.2266 60.5479 56.2215 60.6479C56.2198 60.7371 55.9723 69.6855 64.4773 74.7114C64.5654 74.7631 64.5926 74.8756 64.54 74.9613C64.5078 75.0184 64.4468 75.0506 64.3841 75.0506Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3839 71.9095C64.3211 71.9095 64.2601 71.8773 64.2262 71.8202C64.1737 71.7345 64.2025 71.622 64.2889 71.5702C72.7922 66.5444 72.5464 57.596 72.5447 57.5067C72.5396 57.405 72.6193 57.3211 72.721 57.3175H72.7278C72.8261 57.3175 72.9075 57.3943 72.9109 57.4925C72.9159 57.5853 73.1736 66.7443 64.4788 71.8845C64.4483 71.9005 64.4161 71.9095 64.3839 71.9095Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.949 84.2429C156.871 88.8392 154.385 93.7744 150.699 94.8265C147.666 95.6632 143.98 93.8472 142.41 90.2302C141.934 90.6047 140.841 91.3343 139.27 91.5127C137.612 91.7088 136.342 91.1917 135.796 90.942C132.339 96.3765 126.043 97.6768 122.411 95.0762C121.476 94.4164 120.718 93.4906 120.207 92.4221C119.307 90.7295 118.938 88.6267 119.114 86.5076C118.991 86.3828 117.51 84.8864 117.879 82.7301C118.126 81.1623 119.237 79.8799 120.718 79.3984C119.554 76.3876 119.96 73.0737 121.829 70.8283C123.451 68.8504 125.638 68.3689 126.379 68.2441C125.744 66.3018 126.149 64.1812 127.454 62.7026C128.901 61.0278 131.229 60.4572 133.327 61.2418C133.485 60.8852 134.562 58.6412 136.907 57.9992C139.287 57.3573 142.022 58.6412 143.45 61.2418C143.997 61.0991 146.272 60.5285 148.071 61.8303C150.328 63.4516 151.069 67.3718 149.164 70.9353C150.222 70.6678 151.316 71.0066 151.968 71.8255C152.709 72.7334 152.584 73.8391 152.567 74.0174C154.966 74.9268 156.624 77.1173 156.765 79.5589C156.908 82.1594 155.25 83.9412 154.949 84.2429Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.166 70.9339C148.689 71.237 147.701 71.7898 146.344 71.824C144.227 71.9132 142.781 70.7377 142.411 70.4167C142.552 70.7377 143.293 72.3055 142.658 74.0516C142.04 75.7621 140.365 76.9375 138.425 77.0623C141.177 80.2336 140.384 84.8299 137.668 86.5582C135.464 87.9833 132.042 87.484 129.873 85.0082C129.468 86.0411 128.586 87.8407 126.787 89.4619C124.212 91.7965 121.338 92.2765 120.209 92.4192C119.309 90.7266 118.939 88.6238 119.116 86.5047C118.993 86.3799 117.511 84.8834 117.881 82.7272C118.128 81.1594 119.238 79.8769 120.72 79.3954C119.556 76.3847 119.962 73.0708 121.83 70.8254C123.453 68.8475 125.64 68.366 126.381 68.2411C125.746 66.2989 126.151 64.1783 127.456 62.6997C128.902 61.0249 131.231 60.4542 133.329 61.2389C133.487 60.8822 134.563 58.6383 136.908 57.9963C139.289 57.3543 142.023 58.6383 143.451 61.2389C143.999 61.0962 146.273 60.5256 148.072 61.8273C150.33 63.4516 151.071 67.3703 149.166 70.9339Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.571 109.45H137.905L138.099 101.686V101.15L138.201 92.3659L138.232 89.8233V89.3983L138.334 80.3616V80.0064L138.476 67.6871C138.486 67.5459 138.599 67.4344 138.741 67.4344C138.884 67.4344 138.997 67.5459 138.997 67.6871L139.1 77.2201L139.11 77.5842L139.223 87.5422V88.0281L139.273 92.3748L139.334 97.3798V97.9579L139.571 109.45Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74 90.2851C138.7 90.2851 138.659 90.2702 138.628 90.239L133.22 84.6663C133.16 84.6054 133.163 84.5103 133.225 84.4523C133.285 84.3929 133.383 84.3944 133.443 84.4568L138.851 90.0295C138.91 90.0904 138.908 90.1855 138.845 90.2434C138.817 90.2717 138.778 90.2851 138.74 90.2851Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.683 87.1366C135.683 87.1366 135.682 87.1366 135.679 87.1366C131.497 87.037 127.447 80.7733 127.42 80.7362C127.371 80.6678 127.385 80.5727 127.454 80.5237C127.522 80.4761 127.618 80.4895 127.669 80.5579C127.695 80.5935 131.659 86.7369 135.687 86.8335C135.772 86.8349 135.84 86.9048 135.837 86.988C135.834 87.0712 135.765 87.1366 135.683 87.1366Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.98 87.7396C138.959 87.7292 138.94 87.7143 138.925 87.6935C138.873 87.6252 138.885 87.5301 138.952 87.4796C141.778 85.3486 141.349 80.5352 141.343 80.4862C141.336 80.4015 141.397 80.3287 141.48 80.3227C141.563 80.3183 141.638 80.3807 141.647 80.4654C141.666 80.6705 142.098 85.4957 139.138 87.7262C139.091 87.7619 139.031 87.7649 138.98 87.7396Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.587 80.4951C138.56 80.4951 138.533 80.4877 138.508 80.4743C131.27 76.196 131.484 68.5725 131.488 68.4952C131.491 68.4135 131.559 68.3496 131.641 68.3496H131.646C131.731 68.3526 131.797 68.4239 131.793 68.5071C131.792 68.5814 131.586 76.0295 138.665 80.2128C138.738 80.2558 138.761 80.3495 138.717 80.4208C138.69 80.4683 138.639 80.4951 138.587 80.4951Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.587 77.8808C138.535 77.8808 138.484 77.8541 138.456 77.8065C138.412 77.7352 138.436 77.6416 138.508 77.5985C145.585 73.4152 145.381 65.9672 145.379 65.8929C145.375 65.8082 145.442 65.7383 145.526 65.7354H145.532C145.614 65.7354 145.681 65.7993 145.684 65.881C145.688 65.9583 145.903 73.5817 138.666 77.86C138.64 77.8734 138.614 77.8808 138.587 77.8808Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2896 80.842C23.2052 85.4215 20.7268 90.3384 17.0549 91.3865C14.0323 92.2202 10.3605 90.4098 8.79746 86.8069C8.3228 87.1801 7.23446 87.9067 5.66977 88.0853C4.01861 88.2799 2.75397 87.7657 2.20811 87.5175C-1.2349 92.9308 -7.50724 94.227 -11.1266 91.6364C-12.0572 90.9794 -12.8133 90.0563 -13.3236 88.9922C-14.2203 87.3051 -14.5882 85.2108 -14.4136 83.0987C-14.5357 82.9737 -16.0122 81.4829 -15.6426 79.3351C-15.3968 77.7729 -14.2898 76.4945 -12.8133 76.0161C-13.9728 73.0166 -13.5694 69.7136 -11.7063 67.4783C-10.0908 65.5073 -7.9107 65.0288 -7.17328 64.9038C-7.8056 62.9685 -7.40214 60.8563 -6.1019 59.3834C-4.66095 57.7141 -2.34188 57.1463 -0.251666 57.9283C-0.0940096 57.573 0.977375 55.3377 3.31509 54.6968C5.68672 54.0576 8.41095 55.3359 9.83325 57.9283C10.3774 57.7855 12.6439 57.2177 14.4375 58.5139C16.6871 60.1297 17.4245 64.0343 15.5275 67.5837C16.582 67.3177 17.6703 67.6551 18.3213 68.471C19.0587 69.3762 18.9366 70.476 18.918 70.6545C21.3082 71.5597 22.9594 73.7433 23.1001 76.175C23.2391 78.7656 21.588 80.5402 21.2896 80.842Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5264 67.5823C15.0517 67.884 14.0685 68.4339 12.7157 68.4696C10.6069 68.5589 9.16592 67.3877 8.79805 67.0681C8.93876 67.3877 9.67618 68.9499 9.04386 70.6889C8.42849 72.3921 6.76039 73.5651 4.82613 73.6883C7.56732 76.8484 6.77734 81.428 4.07006 83.1491C1.87305 84.5684 -1.53436 84.0721 -3.69577 81.6047C-4.09924 82.6349 -4.97906 84.4274 -6.77092 86.0432C-9.3358 88.3678 -12.2007 88.848 -13.3247 88.9891C-14.2214 87.3019 -14.5893 85.2076 -14.4147 83.0955C-14.5368 82.9705 -16.0133 81.4797 -15.6437 79.3319C-15.3979 77.7697 -14.2909 76.4914 -12.8144 76.0129C-13.9739 73.0134 -13.5705 69.7105 -11.7074 67.4752C-10.0919 65.5041 -7.91181 65.0256 -7.17438 64.9006C-7.8067 62.9653 -7.40324 60.8532 -6.103 59.3802C-4.66205 57.7109 -2.34298 57.1431 -0.252766 57.9251C-0.09511 57.5698 0.976273 55.3345 3.31399 54.6936C5.68561 54.0544 8.40985 55.3327 9.83214 57.9251C10.3763 57.7823 12.6428 57.2146 14.4364 58.5107C16.6859 60.1283 17.4251 64.0329 15.5264 67.5823Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96836 109.837H4.30704L4.50029 98.2215V97.6858L4.60201 88.9357L4.63252 86.4022V85.9773L4.73423 76.9736V76.6201L4.87663 64.3473C4.8868 64.2063 4.99869 64.0956 5.14109 64.0956C5.28349 64.0956 5.39537 64.2063 5.39537 64.3473L5.49709 73.8456L5.50726 74.208L5.61914 84.1294V84.6132L5.67 88.9428L5.73103 93.9294V94.5043L5.96836 109.837Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13917 86.8628C5.10018 86.8628 5.05949 86.8468 5.02898 86.8164L-0.360153 81.2656C-0.419486 81.2049 -0.416095 81.1085 -0.355067 81.0514C-0.295734 80.9925 -0.197411 80.9943 -0.139773 81.055L5.24936 86.6057C5.30869 86.6664 5.3053 86.7628 5.24427 86.82C5.21715 86.8485 5.17816 86.8628 5.13917 86.8628Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09448 83.7243H2.09109C-2.07578 83.6243 -6.11043 77.3844 -6.13755 77.3469C-6.18671 77.279 -6.17315 77.1844 -6.10364 77.1362C-6.03584 77.088 -5.9409 77.1023 -5.89005 77.1701C-5.86292 77.2058 -1.91474 83.3261 2.09956 83.4226C2.18432 83.4243 2.25044 83.494 2.24874 83.5779C2.24535 83.66 2.17585 83.7243 2.09448 83.7243Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37991 84.326C5.35957 84.3153 5.33923 84.301 5.32566 84.2796C5.27311 84.2117 5.28498 84.1171 5.35109 84.0671C8.16687 81.9443 7.73797 77.1487 7.73458 77.1005C7.72611 77.0166 7.78714 76.9434 7.8702 76.9381C7.95327 76.9327 8.02786 76.9952 8.03633 77.0809C8.05498 77.2844 8.48557 82.0925 5.53757 84.3135C5.4901 84.3474 5.42907 84.351 5.37991 84.326Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98712 77.1075C4.95999 77.1075 4.93287 77.1003 4.90913 77.086C-2.30236 72.8225 -2.08876 65.2275 -2.08537 65.1507C-2.08198 65.0686 -2.01417 65.0061 -1.9328 65.0061C-1.9328 65.0061 -1.92941 65.0061 -1.92602 65.0061C-1.84126 65.0097 -1.77515 65.0793 -1.78023 65.1632C-1.78193 65.2382 -1.98536 72.6565 5.06679 76.8254C5.13969 76.8682 5.16172 76.9611 5.11934 77.0325C5.09052 77.0825 5.03967 77.1075 4.98712 77.1075Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9863 74.5042C4.93545 74.5042 4.88459 74.4774 4.85577 74.431C4.81339 74.3596 4.83543 74.2668 4.90832 74.2239C11.9605 70.055 11.7553 62.635 11.7537 62.5618C11.7503 62.4779 11.8147 62.4082 11.8994 62.4047H11.9045C11.9859 62.4047 12.0537 62.4689 12.0571 62.5493C12.0605 62.6261 12.2741 70.2211 5.06428 74.4846C5.04055 74.4971 5.01343 74.5042 4.9863 74.5042Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.718 85.3158C104.312 89.1276 102.25 93.2201 99.1933 94.0925C96.6775 94.7864 93.6212 93.2796 92.3203 90.2807C91.9252 90.5913 91.0194 91.1961 89.717 91.3447C88.3427 91.5067 87.2901 91.0787 86.8357 90.8722C83.97 95.3779 78.7492 96.4568 75.7367 94.3005C74.9621 93.7536 74.3328 92.9853 73.9081 92.0997C73.1616 90.6953 72.8555 88.9522 73.0008 87.1942C72.8992 87.0902 71.6702 85.8493 71.9778 84.0616C72.1824 82.7613 73.1038 81.6973 74.3328 81.2991C73.3676 78.8025 73.7035 76.0533 75.2542 74.1928C76.5989 72.5522 78.4134 72.1539 79.0272 72.0499C78.5009 70.439 78.8367 68.681 79.919 67.455C81.1183 66.0655 83.0486 65.593 84.7883 66.2439C84.9196 65.9481 85.8113 64.0876 87.7571 63.5541C89.7311 63.0221 91.9986 64.0861 93.1824 66.2439C93.6354 66.125 95.5219 65.6524 97.0147 66.7313C98.8871 68.0762 99.5009 71.3262 97.922 74.2804C98.7996 74.059 99.7055 74.3399 100.247 75.019C100.861 75.7724 100.76 76.6878 100.744 76.8364C102.734 77.5899 104.108 79.4073 104.225 81.4313C104.341 83.5876 102.966 85.0647 102.718 85.3158Z",
    fill: "#37B45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9211 74.2791C97.526 74.5303 96.7076 74.988 95.5816 75.0177C93.8263 75.092 92.627 74.1171 92.3208 73.8511C92.4379 74.1171 93.0517 75.4174 92.5254 76.8648C92.0132 78.2825 90.6248 79.2589 89.0148 79.3614C91.2964 81.9917 90.6389 85.8034 88.3855 87.236C86.5568 88.4174 83.7207 88.0043 81.9217 85.9505C81.5858 86.808 80.8535 88.3 79.3621 89.6449C77.2272 91.5797 74.8426 91.9795 73.9071 92.0969C73.1607 90.6925 72.8545 88.9494 72.9999 87.1914C72.8983 87.0874 71.6693 85.8465 71.9769 84.0588C72.1815 82.7585 73.1029 81.6945 74.3319 81.2962C73.3667 78.7997 73.7026 76.0505 75.2532 74.1899C76.5979 72.5493 78.4125 72.1511 79.0263 72.0471C78.5 70.4362 78.8358 68.6782 79.918 67.4522C81.1174 66.0627 83.0477 65.5902 84.7874 66.2411C84.9186 65.9453 85.8104 64.0848 87.7562 63.5513C89.7302 63.0193 91.9977 64.0833 93.1815 66.2411C93.6344 66.1222 95.521 65.6496 97.0138 66.7285C98.8862 68.0749 99.5014 71.3248 97.9211 74.2791Z",
    fill: "#16CB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9656 109.449H88.5828L88.7436 99.7812V99.3354L88.8283 92.0522L88.8537 89.9435V89.5899L88.9383 82.0957V81.8015L89.0569 71.5864C89.0653 71.469 89.1585 71.3768 89.277 71.3768C89.3955 71.3768 89.4886 71.469 89.4886 71.5864L89.5733 79.4921L89.5818 79.7938L89.6749 88.0518V88.4545L89.7172 92.0582L89.768 96.2087V96.6872L89.9656 109.449Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2752 90.3269C89.2428 90.3269 89.2089 90.3136 89.1835 90.2883L84.6979 85.6682C84.6485 85.6176 84.6513 85.5374 84.7021 85.4898C84.7515 85.4408 84.8334 85.4423 84.8813 85.4928L89.3669 90.113C89.4163 90.1635 89.4135 90.2437 89.3627 90.2913C89.3401 90.315 89.3077 90.3269 89.2752 90.3269Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.741 87.7146H86.7382C83.2699 87.6314 79.9117 82.4376 79.8892 82.4064C79.8482 82.3499 79.8595 82.2712 79.9174 82.2311C79.9738 82.1909 80.0528 82.2028 80.0952 82.2593C80.1177 82.289 83.404 87.3832 86.7452 87.4634C86.8158 87.4649 86.8708 87.5229 86.8694 87.5927C86.8666 87.6611 86.8087 87.7146 86.741 87.7146Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4755 88.2153C89.4586 88.2064 89.4417 88.1945 89.4304 88.1767C89.3866 88.1202 89.3965 88.0415 89.4515 87.9999C91.7952 86.2329 91.4382 82.2414 91.4354 82.2013C91.4284 82.1314 91.4792 82.0705 91.5483 82.0661C91.6174 82.0616 91.6795 82.1136 91.6866 82.1849C91.7021 82.3544 92.0605 86.3563 89.6068 88.2049C89.5672 88.2332 89.5165 88.2361 89.4755 88.2153Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1486 82.2073C89.126 82.2073 89.1035 82.2014 89.0837 82.1895C83.0813 78.6408 83.2591 72.3191 83.2619 72.2552C83.2647 72.1869 83.3212 72.1349 83.3889 72.1349C83.3889 72.1349 83.3917 72.1349 83.3945 72.1349C83.4651 72.1379 83.5201 72.1958 83.5159 72.2657C83.5145 72.3281 83.3451 78.5026 89.2149 81.9725C89.2756 82.0082 89.2939 82.0855 89.2587 82.1449C89.2347 82.1865 89.1924 82.2073 89.1486 82.2073Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1481 80.0404C89.1058 80.0404 89.0634 80.0182 89.0394 79.9795C89.0042 79.9201 89.0225 79.8428 89.0832 79.8071C94.953 76.3372 94.7822 70.1612 94.7808 70.1003C94.778 70.0304 94.8316 69.9725 94.9022 69.9695H94.9064C94.9741 69.9695 95.0306 70.023 95.0334 70.0899C95.0362 70.1538 95.214 76.4754 89.213 80.0241C89.1932 80.0345 89.1707 80.0404 89.1481 80.0404Z",
    fill: "#3A6332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.06 95.759C285.067 104.018 282.531 111.829 278.435 119.21H260.863C258.54 115.018 255.277 108.246 252.954 104.054C255.916 107.403 258.894 110.772 261.856 114.122C259.959 110.378 258.06 106.616 256.163 102.852C259.037 106.703 261.892 110.556 264.763 114.407L255.524 94.2896C258.362 96.8159 262.617 103.39 267.654 112.151C267.335 106.436 266.553 100.901 264.338 96.0268C267.777 98.3014 269.657 105.055 271.359 112.329C272.955 105.629 274.782 98.2121 274.072 90.526C275.331 99.269 276.43 104.07 275.26 111.504C276.608 108.782 277.618 105.163 278.364 100.935C279.056 105.825 277.991 111.145 276.111 116.664C279.783 110.808 283.063 103.695 286.06 95.759Z",
    fill: "#36937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.215 106.491C290.903 111.562 288.775 115.95 285.281 119.21H278.721C282.657 114.517 285.885 109.626 287.499 104.342C287.285 109.285 285.797 113.495 282.764 117.491C286.363 115.036 289.465 111.221 292.215 106.491Z",
    fill: "#36937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.732 111.417C293.491 114.409 291.54 116.971 289.127 119.21H285.723C289.058 117.15 292.072 114.57 294.732 111.417Z",
    fill: "#36937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9397 110.874C32.2524 116.588 30.4977 121.992 27.6641 127.099H15.5061C13.8992 124.198 11.6414 119.513 10.0346 116.613C12.0836 118.93 14.1444 121.261 16.1934 123.578C14.8809 120.988 13.5673 118.385 12.2549 115.781C14.2429 118.446 16.218 121.112 18.2048 123.776L11.8127 109.857C13.7761 111.605 16.72 116.153 20.2046 122.215C19.9841 118.261 19.4434 114.431 17.9104 111.059C20.2902 112.633 21.5909 117.306 22.7685 122.338C23.8722 117.702 25.1365 112.571 24.6451 107.253C25.5165 113.302 26.2766 116.624 25.4673 121.768C26.3997 119.884 27.0987 117.38 27.6148 114.455C28.0933 117.838 27.3568 121.519 26.0561 125.337C28.5965 121.286 30.866 116.365 32.9397 110.874Z",
    fill: "#36937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1976 118.299C36.2898 121.807 34.8178 124.843 32.4005 127.099H27.8615C30.5849 123.851 32.8181 120.468 33.9346 116.812C33.7869 120.232 32.7571 123.145 30.6588 125.909C33.1488 124.211 35.2952 121.571 37.1976 118.299Z",
    fill: "#36937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9391 121.707C38.0805 123.777 36.7305 125.55 35.0615 127.099H32.7064C35.0135 125.673 37.0988 123.888 38.9391 121.707Z",
    fill: "#36937A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.843 130.544C114.222 135.687 112.638 140.551 110.079 145.147H99.0991C97.648 142.537 95.609 138.32 94.1579 135.709C96.0083 137.795 97.8694 139.893 99.7198 141.979C98.5346 139.647 97.3482 137.305 96.163 134.961C97.9583 137.359 99.742 139.758 101.536 142.156L95.7637 129.629C97.5368 131.202 100.195 135.295 103.342 140.751C103.143 137.192 102.655 133.746 101.27 130.71C103.42 132.127 104.594 136.333 105.658 140.862C106.654 136.69 107.796 132.071 107.352 127.285C108.139 132.729 108.826 135.719 108.095 140.349C108.937 138.653 109.568 136.4 110.034 133.767C110.467 136.812 109.801 140.125 108.627 143.562C110.921 139.915 112.971 135.486 114.843 130.544Z",
    fill: "#36937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.688 137.227C117.869 140.384 116.539 143.117 114.356 145.147H110.257C112.717 142.224 114.733 139.179 115.742 135.888C115.608 138.967 114.678 141.589 112.783 144.077C115.032 142.548 116.97 140.172 118.688 137.227Z",
    fill: "#36937A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.261 140.294C119.486 142.158 118.267 143.753 116.759 145.147H114.633C116.716 143.864 118.599 142.258 120.261 140.294Z",
    fill: "#36937A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_8101",
    x1: 194.665,
    y1: -21.3244,
    x2: 194.665,
    y2: -77.2821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1595,
    stopColor: "#EDF0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8351,
    stopColor: "#D5EFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_491_8101",
    x1: 227.837,
    y1: 112.578,
    x2: 219.863,
    y2: 143.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_491_8101",
    x1: 32.1792,
    y1: 158.854,
    x2: -2.15364,
    y2: 198.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_491_8101",
    x1: 205.749,
    y1: 158.422,
    x2: 184.853,
    y2: 222.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_491_8101",
    x1: 330.932,
    y1: 169.231,
    x2: 318.896,
    y2: 195.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_491_8101",
    x1: 142.159,
    y1: 90.9869,
    x2: 125.745,
    y2: 153.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_491_8101",
    x1: 452.317,
    y1: 87.3358,
    x2: 436.001,
    y2: 163.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_491_8101",
    x1: 190.606,
    y1: 102.346,
    x2: 183.508,
    y2: 126.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_491_8101",
    x1: 74.0558,
    y1: 114.952,
    x2: 56.5553,
    y2: 147.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_8101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 178,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_491_8101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 314,
    height: 190.927,
    fill: "white",
    transform: "translate(-9 -12.9274)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentillustration);
export default __webpack_public_path__ + "static/media/environment illustration.ae7adfebc608cb23ae8b5933c1027637.svg";
export { ForwardRef as ReactComponent };